var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 56,
    viewBox: "0 0 94 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1491 39.6938V52.1214L56.0199 50.5844L53.0065 49.4602L47.3486 47.3524V40.2998L53.0065 40.0276L53.7093 40.0012L60.1491 39.6938Z",
    fill: "url(#paint0_radial_578_447537)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0203 40.8267V50.5843L53.0068 49.4601V39.7465L53.7097 40.0011L56.0203 40.8267Z",
    fill: "url(#paint1_radial_578_447537)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1491 51.4274V52.1213L56.0199 50.5843L53.0065 49.4601L47.3486 47.3523L47.4101 46.6145L60.1491 51.4274Z",
    fill: "url(#paint2_radial_578_447537)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6094 39.6941V52.1216L38.7298 50.5846L41.7344 49.4605L47.4098 47.3526V40.3001L41.7344 40.0278L41.0403 40.0015L34.6094 39.6941Z",
    fill: "url(#paint3_radial_578_447537)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7295 40.827V50.5845L41.7341 49.4604V39.7467L41.0401 40.0014L38.7295 40.827Z",
    fill: "url(#paint4_radial_578_447537)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6094 51.4277V52.1215L38.7298 50.5845L41.7344 49.4604L47.4098 47.3525L47.3395 46.6147L34.6094 51.4277Z",
    fill: "url(#paint5_radial_578_447537)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6742 34.4508V46.8696L58.8029 46.2021L56.466 45.3765L47.3467 42.1093V35.0481L56.466 34.6353L58.8029 34.5299L60.6742 34.4508Z",
    fill: "url(#paint6_radial_578_447537)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8028 34.5298V46.202L56.4658 45.3764V34.6352L58.8028 34.5298Z",
    fill: "url(#paint7_radial_578_447537)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6742 46.2283V46.8695L58.8029 46.202L56.466 45.3765L47.3467 42.1093V41.6086L60.6742 46.2283Z",
    fill: "url(#paint8_radial_578_447537)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0811 34.4508V46.8696L35.9436 46.2021L38.2805 45.3765L47.4086 42.1093V35.0481L38.2805 34.6353L35.9436 34.5299L34.0811 34.4508Z",
    fill: "url(#paint9_radial_578_447537)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9434 34.5298V46.202L38.2803 45.3764V34.6352L35.9434 34.5298Z",
    fill: "url(#paint10_radial_578_447537)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0811 46.2283V46.8695L35.9436 46.202L38.2805 45.3764L47.4086 42.1093V41.6086L34.0811 46.2283Z",
    fill: "url(#paint11_radial_578_447537)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3749 27.8902C52.7704 27.8902 57.1444 23.5177 57.1444 18.1239C57.1444 12.7301 52.7704 8.35754 47.3749 8.35754C41.9794 8.35754 37.6055 12.7301 37.6055 18.1239C37.6055 23.5177 41.9794 27.8902 47.3749 27.8902Z",
    fill: "#83E9F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.379 30.9629C53.8204 30.9629 59.0422 25.7428 59.0422 19.3034C59.0422 12.864 53.8204 7.64392 47.379 7.64392C40.9376 7.64392 35.7158 12.864 35.7158 19.3034C35.7158 25.7428 40.9376 30.9629 47.379 30.9629Z",
    fill: "#277BFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3749 28.1535C52.7704 28.1535 57.1444 23.781 57.1444 18.3872C57.1444 12.9934 52.7704 8.62085 47.3749 8.62085C41.9794 8.62085 37.6055 12.9934 37.6055 18.3872C37.6055 23.781 41.9794 28.1535 47.3749 28.1535Z",
    fill: "url(#paint12_radial_578_447537)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3743 27.8461C52.2458 27.8461 56.1949 23.8982 56.1949 19.0283C56.1949 14.1584 52.2458 10.2104 47.3743 10.2104C42.5028 10.2104 38.5537 14.1584 38.5537 19.0283C38.5537 23.8982 42.5028 27.8461 47.3743 27.8461Z",
    fill: "url(#paint13_radial_578_447537)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3356 18.8262C56.3356 20.249 56.0017 21.5928 55.4043 22.7785C53.9547 25.6592 50.9676 27.6441 47.5237 27.6441C42.6566 27.6441 38.7031 23.7006 38.7031 18.8262C38.7031 16.7535 39.4147 14.8565 40.6096 13.3459C42.2261 11.3171 44.7212 10.0084 47.515 10.0084C52.3821 9.99965 56.3356 13.9519 56.3356 18.8262Z",
    fill: "url(#paint14_radial_578_447537)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4269 25.7205C51.1436 25.7205 54.1566 22.9248 54.1566 19.476C54.1566 16.0273 51.1436 13.2316 47.4269 13.2316C43.7102 13.2316 40.6973 16.0273 40.6973 19.476C40.6973 22.9248 43.7102 25.7205 47.4269 25.7205Z",
    fill: "url(#paint15_radial_578_447537)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3955 22.7696C53.9459 25.6504 50.9589 27.6353 47.5149 27.6353C42.6478 27.6353 38.6943 23.6918 38.6943 18.8174C38.6943 16.7447 39.406 14.8477 40.6008 13.337C40.5832 14.4173 41.0401 15.7435 42.5951 17.2278C45.4767 19.9943 51.4421 20.7672 55.3955 22.7696Z",
    fill: "url(#paint16_radial_578_447537)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6338 22.7696C41.0834 25.6504 44.0705 27.6353 47.5144 27.6353C52.3815 27.6353 56.335 23.6918 56.335 18.8174C56.335 16.7447 55.6234 14.8477 54.4285 13.337C54.4461 14.4173 53.9893 15.7435 52.4342 17.2278C49.5438 19.9943 43.596 20.7672 39.6338 22.7696Z",
    fill: "url(#paint17_radial_578_447537)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 12.0901C44.1496 12.0901 41.2416 14.0223 39.8359 16.8327C40.5212 17.4914 41.3207 18.0448 42.2256 18.5015C43.0866 16.42 45.1336 14.9532 47.5144 14.9532C49.8953 14.9532 51.9511 16.42 52.8033 18.5015C53.7082 18.0448 54.5165 17.4827 55.1929 16.8327C53.7873 14.0135 50.8705 12.0901 47.5144 12.0901Z",
    fill: "url(#paint18_radial_578_447537)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3786 7.64453C42.7544 7.64453 38.758 10.6564 36.8262 15.0373C37.7679 16.064 38.8666 16.9265 40.1102 17.6384C41.2934 14.3938 44.1066 12.1075 47.3786 12.1075C50.6506 12.1075 53.4758 14.3938 54.647 17.6384C55.8906 16.9265 57.0014 16.0503 57.931 15.0373C55.9992 10.6427 51.9908 7.64453 47.3786 7.64453Z",
    fill: "url(#paint19_radial_578_447537)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5153 26.5288C49.9225 26.5288 52.0047 25.4046 53.015 23.7798C52.5318 23.4022 51.952 23.0684 51.3019 22.8137C50.6869 24.0169 49.2197 24.8689 47.5065 24.8689C45.7934 24.8689 44.335 24.0169 43.7112 22.8137C43.0611 23.0772 42.4812 23.4022 41.998 23.7798C43.0259 25.4046 45.1081 26.5288 47.5153 26.5288Z",
    fill: "url(#paint20_radial_578_447537)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4353 19.0282C58.4353 21.786 57.425 24.3154 55.7557 26.2476C53.7263 28.6013 50.7304 30.0856 47.3832 30.0856C44.0359 30.0856 41.0401 28.6013 39.0106 26.2476C37.3414 24.3154 36.3311 21.786 36.3311 19.0282C36.3311 13.8377 39.898 9.49022 44.73 8.29578V11.563C43.6406 11.9494 42.6302 12.5817 41.7868 13.4249C40.2933 14.9179 39.4675 16.9116 39.4675 19.0282C39.4675 20.776 40.0297 22.4359 41.0664 23.7972C41.2861 24.087 41.5233 24.3593 41.7868 24.6228C43.2804 26.1158 45.2747 26.9414 47.392 26.9414C49.5093 26.9414 51.4948 26.1158 52.9971 24.6228C53.2607 24.3593 53.4979 24.087 53.7175 23.7972C54.7542 22.4271 55.3165 20.776 55.3165 19.0282C55.3165 16.9116 54.4906 14.9267 52.9971 13.4249C52.1537 12.5817 51.1522 11.9494 50.054 11.563V8.29578C54.8157 9.47266 58.3562 13.7323 58.4441 18.835C58.4353 18.8965 58.4353 18.958 58.4353 19.0282Z",
    fill: "url(#paint21_radial_578_447537)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7471 26.2389C53.7176 28.5927 50.7218 30.077 47.3745 30.077C44.0272 30.077 41.0314 28.5927 39.002 26.2389L41.049 23.7886C41.2686 24.0784 41.5058 24.3507 41.7694 24.6141C43.2629 26.1072 45.2572 26.9328 47.3745 26.9328C49.4918 26.9328 51.4773 26.1072 52.9796 24.6141C53.2432 24.3507 53.4804 24.0784 53.7 23.7886L55.7471 26.2389Z",
    fill: "url(#paint22_radial_578_447537)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0361 10.1226V11.563C51.1255 11.9494 52.1359 12.5817 52.9793 13.4249C54.4728 14.9179 55.2986 16.9116 55.2986 19.0282C55.2986 21.1449 54.4728 23.1297 52.9793 24.6316C51.4857 26.1334 49.4914 26.9502 47.3741 26.9502C45.2568 26.9502 43.2713 26.1246 41.769 24.6316C40.2755 23.1385 39.4496 21.1449 39.4496 19.0282C39.4496 16.9116 40.2755 14.9267 41.769 13.4249C42.6124 12.5817 43.6227 11.9494 44.7121 11.563V10.1226C40.8641 11.2643 38.0527 14.8389 38.0527 19.0546C38.0527 24.2012 42.2258 28.373 47.3741 28.373C52.5224 28.373 56.6955 24.2012 56.6955 19.0546C56.6955 14.8301 53.8842 11.2643 50.0361 10.1226Z",
    fill: "url(#paint23_radial_578_447537)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7215 8.29578V11.563L44.2031 10.2016L44.7215 8.29578Z",
    fill: "url(#paint24_radial_578_447537)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0098 8.29578V11.563L50.5193 10.2016L50.0098 8.29578Z",
    fill: "url(#paint25_radial_578_447537)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4351 18.835L56.7043 19.0458C56.7043 12.2743 50.5281 10.1928 50.5281 10.1928L50.0449 8.39239V8.29578C54.7979 9.47266 58.3384 13.7323 58.4351 18.835Z",
    fill: "url(#paint26_radial_578_447537)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3223 18.8351L38.053 19.0459C38.053 12.2744 44.2292 10.193 44.2292 10.193L44.7124 8.39252V8.2959C39.9507 9.47278 36.4101 13.7324 36.3223 18.8351Z",
    fill: "url(#paint27_radial_578_447537)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3749 9.70105C47.3222 9.70105 47.2783 9.70105 47.2344 9.70105C52.4266 9.78009 56.5997 14.0046 56.5997 19.2039C56.5997 24.4033 52.4178 28.6277 47.2344 28.7068C47.2783 28.7068 47.331 28.7068 47.3749 28.7068C52.6287 28.7068 56.8896 24.4472 56.8896 19.1951C56.8896 13.9519 52.6287 9.70105 47.3749 9.70105Z",
    fill: "url(#paint28_radial_578_447537)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3223 9.70105C47.3662 9.70105 47.4189 9.70105 47.4629 9.70105C42.2706 9.78009 38.0975 14.0046 38.0975 19.2039C38.0975 24.4033 42.2794 28.6277 47.4629 28.7068C47.4189 28.7068 47.3662 28.7068 47.3223 28.7068C42.0686 28.7068 37.8076 24.4472 37.8076 19.1951C37.8076 13.9519 42.0686 9.70105 47.3223 9.70105Z",
    fill: "url(#paint29_radial_578_447537)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8887 19.0457C56.8887 19.0018 56.8887 18.9491 56.8887 18.9052C56.8097 24.0957 52.5838 28.2675 47.3828 28.2675C42.1818 28.2675 37.956 24.0869 37.877 18.9052C37.877 18.9491 37.877 19.0018 37.877 19.0457C37.877 24.2977 42.1379 28.5574 47.3916 28.5574C52.6278 28.5574 56.8887 24.2977 56.8887 19.0457Z",
    fill: "url(#paint30_radial_578_447537)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0361 8.29578L50.4227 10.2016L50.0098 11.5542L50.5457 10.4387C50.5457 10.4387 52.3643 10.7901 53.6997 12.2041C53.6997 12.2041 52.6893 11.0799 50.5984 10.1226L50.0361 8.29578Z",
    fill: "url(#paint31_radial_578_447537)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7212 8.32227L44.3346 10.2281L44.7475 11.5807L44.2116 10.4653C44.2116 10.4653 42.393 10.8165 41.0576 12.2306C41.0576 12.2306 42.0679 11.1064 44.1589 10.1491L44.7212 8.32227Z",
    fill: "url(#paint32_radial_578_447537)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3741 12.3447L45.2656 8.95458L47.3741 5.56445L49.4914 8.95458L47.3741 12.3447Z",
    fill: "url(#paint33_radial_578_447537)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.459 8.94569L46.6626 8.2782H48.121L49.4915 8.95448L48.0771 9.70101H46.6187L45.459 8.94569Z",
    fill: "url(#paint34_radial_578_447537)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3741 5.56445L46.5659 8.98091L45.2656 8.95458L47.3741 5.56445Z",
    fill: "url(#paint35_radial_578_447537)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3737 5.56445L48.182 8.98091H46.5654L47.3737 5.56445Z",
    fill: "url(#paint36_radial_578_447537)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5659 8.9808L47.3741 12.3446L45.2656 8.95447L46.5659 8.9808Z",
    fill: "url(#paint37_radial_578_447537)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1823 8.9808L47.374 12.3446L49.4913 8.95447L48.1823 8.9808Z",
    fill: "url(#paint38_radial_578_447537)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3737 5.56445L48.3313 8.80526L49.491 8.95458L48.2962 9.05999L47.3737 12.3447L48.1029 9.09511L46.5654 8.98091L48.138 8.87554L47.3737 5.56445Z",
    fill: "url(#paint39_radial_578_447537)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4093 5.56445L46.4517 8.80526L45.292 8.95458L46.4868 9.05999L47.4093 12.3447L46.6713 9.09511L48.2176 8.98091L46.6362 8.87554L47.4093 5.56445Z",
    fill: "url(#paint40_radial_578_447537)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4092 5.56445L49.4913 8.95458L47.4092 12.3447L49.2629 8.9897L47.4092 5.56445Z",
    fill: "url(#paint41_radial_578_447537)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3829 5.54688L45.4589 8.94575L47.4093 12.3447L45.2744 8.96333L47.3829 5.54688Z",
    fill: "url(#paint42_radial_578_447537)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8296 23.2884C58.8296 23.2884 80.3628 17.3776 82.1199 13.847C83.877 10.3163 83.754 8.18213 83.754 8.18213C83.754 8.18213 62.7304 20.513 57.4415 20.2583C57.4328 20.2759 56.1764 23.1654 58.8296 23.2884Z",
    fill: "url(#paint43_radial_578_447537)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8552 22.1114C79.634 22.8667 77.5782 23.3059 75.7948 23.7626C74.6351 24.0524 73.6072 24.351 73.0098 24.7462C73.0098 24.7462 73.4139 20.0299 75.3028 19.3975C75.3116 19.3975 75.3203 19.3888 75.3379 19.3888C75.5927 19.3009 75.8826 19.2043 76.2077 19.0902C76.8227 18.8794 77.5519 18.6159 78.2898 18.3261C80.0821 17.6147 81.9446 16.7364 82.5508 15.946C82.542 15.9284 82.8671 20.8467 80.8552 22.1114Z",
    fill: "url(#paint44_radial_578_447537)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3031 19.3887C75.3382 19.3712 75.3821 19.3536 75.4436 19.3273C75.3997 19.3448 75.3646 19.3624 75.3382 19.38C75.268 19.4239 75.2504 19.4239 75.3031 19.3887Z",
    fill: "url(#paint45_radial_578_447537)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.542 15.9283C81.6898 17.0525 78.325 18.3436 76.2077 19.0813C75.8826 19.1955 75.5839 19.2921 75.3379 19.38C75.3291 19.38 75.3203 19.3887 75.3028 19.3887C75.1007 19.4502 74.9162 19.5644 74.7581 19.7137C74.8459 19.661 74.9426 19.6171 75.048 19.5907C75.0568 19.5907 75.0656 19.582 75.0831 19.582C75.3379 19.5029 75.6278 19.4151 75.9529 19.3097C78.079 18.6334 81.435 17.4566 82.2872 16.4378C82.2872 16.4378 82.6035 20.9257 80.5916 22.0762C78.694 23.1565 74.7756 23.5166 73.0537 24.3158C73.0185 24.5881 73.001 24.755 73.001 24.755C74.5121 23.7449 78.8257 23.3761 80.8376 22.1289C82.8671 20.8467 82.542 15.9283 82.542 15.9283Z",
    fill: "url(#paint46_radial_578_447537)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3552 19.8015C75.3552 19.8015 78.0435 18.9144 79.2208 18.4226C79.2208 18.4226 77.6218 20.2231 76.4973 22.9896C76.4973 22.9896 74.2306 23.4463 73.4311 23.9557C73.4136 23.9557 73.8792 20.5568 75.3552 19.8015Z",
    fill: "url(#paint47_radial_578_447537)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8238 24.8342C77.8238 24.8342 77.7887 25.0011 77.7096 25.2822C77.4461 26.2658 76.6729 28.5669 75.1618 29.0587C74.3184 29.331 73.1324 29.4627 71.8936 29.6296C70.2859 29.8404 68.5815 30.1214 67.3428 30.8592C67.3428 30.8592 67.6415 29.41 68.8012 28.0926C69.3898 27.4339 70.1981 26.8016 71.2962 26.4064C72.4911 25.976 73.6859 25.651 74.7138 25.4139C76.5236 25.0011 77.8238 24.8342 77.8238 24.8342Z",
    fill: "url(#paint48_radial_578_447537)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8238 24.8342C77.6833 24.8518 74.5205 25.2646 71.305 26.4064C70.1981 26.7928 69.3986 27.4339 68.8099 28.0926C69.6446 27.3549 71.9464 25.853 77.3319 25.3173C76.9892 26.4239 76.2337 28.2507 74.9071 28.6811C73.106 29.2695 69.7588 29.1904 67.5273 30.2356C67.3867 30.6132 67.3428 30.8504 67.3428 30.8504C69.5479 29.5418 73.229 29.6823 75.1706 29.0499C76.6817 28.5581 77.4461 26.257 77.7184 25.2734C77.7887 25.0011 77.8238 24.8342 77.8238 24.8342Z",
    fill: "url(#paint49_radial_578_447537)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3756 26.819C71.3756 26.819 69.4252 27.4865 68.0723 29.7788C68.0723 29.7788 68.4764 29.5153 70.0226 29.243C70.0139 29.2518 70.9978 27.0912 71.3756 26.819Z",
    fill: "url(#paint50_radial_578_447537)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5709 30.499C72.5709 30.499 72.5534 30.5869 72.5094 30.7362C72.3513 31.307 71.8593 32.7298 70.8578 33.1865C70.2516 33.4676 69.1709 33.4237 68.0113 33.3446C67.9761 33.3446 67.9498 33.3359 67.9146 33.3359C66.6847 33.2392 65.3844 33.0987 64.5146 33.2392C64.5146 33.2392 64.5761 33.1865 64.7079 33.0987C65.2614 32.7211 66.957 31.6408 69.4697 30.9997C69.8914 30.8855 70.3306 30.7889 70.805 30.7098C71.3585 30.6132 71.9472 30.5342 72.5709 30.499Z",
    fill: "url(#paint51_radial_578_447537)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5709 30.4991C72.5621 30.4991 72.5709 30.4991 72.5709 30.4991C72.4304 30.5079 72.281 30.5167 72.1404 30.5343C72.1317 30.5343 72.1317 30.5343 72.1229 30.5343C68.1694 30.8944 65.4371 32.5982 64.7167 33.1076C64.8134 33.0461 67.9146 31.2545 72.0526 30.789C71.8417 31.474 71.4025 32.4753 70.6206 32.8881C69.4872 33.4765 66.509 32.9408 64.7167 33.1164C64.5937 33.2042 64.5234 33.2569 64.5234 33.2569C66.2278 32.9847 69.6102 33.7927 70.8665 33.213C71.8681 32.7563 72.3513 31.3247 72.5182 30.7626C72.5446 30.587 72.5709 30.4991 72.5709 30.4991Z",
    fill: "url(#paint52_radial_578_447537)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9084 31.2457C69.9084 31.2457 69.5394 31.8342 69.1617 33.0023C69.1617 33.0023 66.7369 32.7915 65.6914 32.9496C65.7002 32.9496 67.4573 31.6673 69.9084 31.2457Z",
    fill: "url(#paint53_radial_578_447537)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2111 28.2507C67.2111 28.2507 67.1935 28.3737 67.1496 28.5845C66.9563 29.41 66.2447 31.553 64.1538 32.3961C63.5037 32.6596 61.8081 33.0812 60.3584 33.046C59.3042 33.0197 58.3817 32.7474 58.083 31.9921C58.083 31.9921 58.1182 31.4564 58.821 30.7801C59.4799 30.139 60.7538 29.3749 63.1522 28.8304C64.2416 28.5757 65.577 28.3737 67.2111 28.2507Z",
    fill: "url(#paint54_radial_578_447537)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1675 28.4703C67.1675 28.4615 67.1763 28.4527 67.1763 28.4351C67.1763 28.4351 67.1763 28.4352 67.1763 28.4264C67.2026 28.3122 67.2114 28.2419 67.2114 28.2419C67.0796 28.2507 66.9478 28.2595 66.8249 28.2771C61.9138 28.6986 59.7525 29.8579 58.8125 30.7626C59.4099 30.3761 62.2125 28.6986 66.7546 28.5845C66.5261 29.4715 65.797 31.4828 63.7851 32.282C62.9944 32.5982 60.6487 33.169 59.0848 32.8353C60.6135 33.3535 63.2843 32.7211 64.1453 32.3786C66.2362 31.5442 66.9391 29.3925 67.1411 28.5669C67.1587 28.5405 67.1675 28.5054 67.1675 28.4703Z",
    fill: "url(#paint55_radial_578_447537)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M65.656 28.8567C65.656 28.8567 64.0747 31.7023 63.9517 32.0448C63.9517 32.0448 61.4215 32.7386 60.3848 32.6772C60.3848 32.6772 61.6499 30.0248 62.4669 29.5242L65.656 28.8567Z",
    fill: "url(#paint56_radial_578_447537)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6607 26.9595C66.1744 27.548 64.1362 27.6446 62.3527 28.0662C60.9646 28.3911 59.7258 28.9269 58.5574 30.0335C58.5574 30.0335 57.96 25.0976 58.8561 23.9032C58.9703 23.8856 63.6266 23.0161 67.5186 22.0325C69.8731 21.444 71.9377 20.8116 72.5526 20.311C72.5526 20.311 72.5614 20.4867 72.5702 20.7765C72.5878 22.1291 72.2979 26.0901 68.6607 26.9595Z",
    fill: "url(#paint57_radial_578_447537)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5529 20.2936C72.5265 20.3111 72.4914 20.3375 72.465 20.3638C72.4562 20.3638 72.4562 20.3726 72.4562 20.3726C72.4211 20.3902 72.3947 20.4078 72.3596 20.4341C72.3596 20.4341 72.3508 20.4341 72.3508 20.4429C72.2717 20.4868 72.1839 20.5395 72.0784 20.5834C69.3286 21.9271 59.0408 23.8505 58.8651 23.8769C62.432 23.5783 69.7942 21.5495 72.0697 20.8996C72.0082 22.5332 71.4635 25.8618 68.1689 26.6434C63.987 27.6359 61.0878 27.2231 58.5049 29.331C58.54 29.7525 58.5752 30.016 58.5752 30.016C61.2723 27.469 64.2594 27.996 68.6785 26.942C73.0976 25.8881 72.5529 20.2936 72.5529 20.2936Z",
    fill: "url(#paint58_radial_578_447537)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1452 21.7252C70.1452 21.7252 68.3442 25.3261 68.0279 26.4327C68.0279 26.4327 66.2005 26.907 64.6543 27.0651C64.6543 27.0651 66.5871 23.5257 66.9912 22.6738C66.9824 22.6738 69.5039 22.1644 70.1452 21.7252Z",
    fill: "url(#paint59_radial_578_447537)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7648 34.1438C67.7648 34.1438 67.7033 34.2492 67.6066 34.4073C67.3431 34.8025 66.772 35.5403 66.1219 35.6456C65.665 35.7247 64.7689 35.6808 64.0046 35.6193C63.2842 35.5578 62.678 35.4876 62.678 35.4876C62.678 35.4876 62.2299 34.5917 63.0558 34.2931C63.2051 34.2404 65.3576 34.1965 66.7017 34.1702C67.3167 34.1526 67.7648 34.1438 67.7648 34.1438Z",
    fill: "url(#paint60_radial_578_447537)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7645 34.1439C67.7645 34.1351 67.7645 34.1351 67.7645 34.1439C67.7645 34.1351 67.6152 34.1439 67.378 34.1439C67.378 34.1439 67.378 34.1439 67.378 34.1527C66.271 34.1703 63.2312 34.223 63.0643 34.2932L67.2286 34.3986C66.9475 34.8027 66.517 35.2857 66.025 35.4087C65.2431 35.5843 63.1521 35.4965 62.6777 35.4701C62.6865 35.4877 62.6865 35.5052 62.6865 35.5052C62.6865 35.5052 65.2343 35.8039 66.1304 35.6546C66.7805 35.5404 67.3428 34.8202 67.6152 34.425H67.624C67.7118 34.2493 67.7645 34.1439 67.7645 34.1439Z",
    fill: "url(#paint61_radial_578_447537)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0586 34.416C65.0586 34.416 64.9005 34.5039 64.839 34.5741C64.6633 34.7322 64.5051 35.0659 64.3997 35.4348L62.8008 35.3558C62.8008 35.3558 62.5899 34.7322 63.2312 34.4775C63.7496 34.2579 65.0586 34.416 65.0586 34.416Z",
    fill: "url(#paint62_radial_578_447537)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M83.754 8.19104C83.754 8.19104 68.1423 17.1143 62.827 18.8269C62.827 18.8269 67.6503 17.4656 83.1918 8.8322C83.0776 9.76317 82.7174 11.4319 81.6104 13.6539C79.8533 17.1757 58.3201 23.0953 58.3201 23.0953C58.1268 23.0865 57.9511 23.0602 57.793 23.025C58.039 23.1743 58.3816 23.2797 58.8297 23.2973C58.8297 23.2973 80.3629 17.3865 82.1199 13.8559C83.877 10.3252 83.754 8.19104 83.754 8.19104Z",
    fill: "url(#paint63_radial_578_447537)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7226 13.7329C74.7226 13.7329 71.0766 15.63 70.4528 15.8671C70.4528 15.8671 68.9505 19.1167 67.3516 20.0389L71.7179 18.3702C71.7179 18.3702 73.1148 14.9449 74.7226 13.7329Z",
    fill: "url(#paint64_radial_578_447537)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0186 28.5226C53.7871 29.7873 51.1778 30.5514 49.6843 29.3745C49.4031 29.1637 49.1747 28.8739 48.9727 28.5226L50.6507 23.4198C50.6507 23.4198 54.2615 22.2781 55.1401 16.7362C55.1401 16.7362 58.1359 13.8379 63.2403 12.6874C63.2315 12.6786 65.5772 23.1124 56.0186 28.5226Z",
    fill: "url(#paint65_linear_578_447537)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2315 12.6788C58.461 14.4793 55.6672 16.7628 55.6672 16.7628C55.184 22.0851 51.0724 23.9383 51.0724 23.9383L49.6755 29.3747C49.3944 29.1639 49.1659 28.8741 48.9639 28.5228L50.6419 23.4201C50.6419 23.4201 54.2527 22.2783 55.1313 16.7365C55.1313 16.7277 58.1271 13.8294 63.2315 12.6788Z",
    fill: "url(#paint66_radial_578_447537)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6758 29.3746L51.0727 23.9381C51.0727 23.9381 55.2633 22.0059 55.6675 16.7627C55.6675 16.7627 59.9109 13.6009 63.2318 12.6787C63.2318 12.6787 56.6339 15.7966 56.0716 16.9998C56.0716 16.9998 55.9925 21.5931 51.5559 24.0962C51.5647 24.0962 49.8954 28.6105 49.6758 29.3746Z",
    fill: "url(#paint67_radial_578_447537)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8682 30.7008C49.8682 30.7008 55.5963 21.9093 62.6071 20.5392C62.6071 20.5392 64.1709 16.631 63.2221 12.7227C63.2221 12.7227 60.2702 20.6183 51.3968 24.8164C51.3968 24.8252 51.7131 27.4864 49.8682 30.7008Z",
    fill: "url(#paint68_radial_578_447537)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4333 12.863C63.4333 12.863 65.7702 25.7648 50.6943 31.5614C50.6943 31.5614 65.0498 28.3381 63.4333 12.863Z",
    fill: "url(#paint69_radial_578_447537)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7141 15.9458C57.7141 15.9458 60.6748 13.8204 62.6691 13.2583C62.6691 13.2583 59.9807 18.6245 55.8164 21.637C55.8164 21.6458 56.7916 20.021 57.7141 15.9458Z",
    fill: "url(#paint70_radial_578_447537)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1992 30.4372C48.1992 30.4372 50.6679 20.1439 63.6089 20.1439L63.3454 27.539C63.3454 27.539 54.8938 28.6807 55.333 31.2365L48.1992 30.4372Z",
    fill: "url(#paint71_radial_578_447537)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6002 20.1352L63.3367 27.5302L62.748 27.5126L62.994 20.0649L63.6002 20.1352Z",
    fill: "url(#paint72_radial_578_447537)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9941 20.0649C62.9941 20.0649 55.2716 22.2782 53.2246 30.9204C53.2246 30.9204 57.6701 26.7837 62.5987 27.4863L62.9941 20.0649Z",
    fill: "url(#paint73_radial_578_447537)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1992 30.4373C48.1992 30.4373 50.3868 23.1301 62.8183 22.893L62.994 20.0649C62.994 20.0649 51.2126 20.1089 48.1992 30.4373Z",
    fill: "url(#paint74_radial_578_447537)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4141 27.5127C62.4141 27.5127 54.4018 24.9921 48.1992 30.4374L55.333 31.2278C55.3242 31.2278 54.3491 28.9355 62.4141 27.5127Z",
    fill: "url(#paint75_radial_578_447537)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M63.284 20.1528L63.0907 27.4951L62.748 27.5126L62.994 20.0649L63.284 20.1528Z",
    fill: "url(#paint76_radial_578_447537)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M48.252 30.3232C48.252 30.3232 51.6695 20.3548 63.0467 20.0299C63.0379 20.0299 51.6431 19.7049 48.252 30.3232Z",
    fill: "url(#paint77_radial_578_447537)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3247 31.2278C55.3247 31.2278 54.3408 28.874 63.3371 27.5303C63.3371 27.5303 54.5252 28.3822 55.3247 31.2278Z",
    fill: "url(#paint78_radial_578_447537)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M60.6489 19.8631C60.6489 23.262 59.2344 26.336 56.9677 28.5228C55.1579 30.2706 52.8034 31.4475 50.1854 31.79L49.7109 27.9432C51.4768 27.7061 53.1109 26.9068 54.3936 25.6246C55.9311 24.0876 56.7832 22.0325 56.7832 19.8544C56.7832 19.7402 56.7832 19.626 56.7745 19.5118H60.6401C60.6489 19.6348 60.6489 19.749 60.6489 19.8631Z",
    fill: "#D7FEFF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8568 19.5557C58.8568 19.5557 58.7601 29.0673 50.0801 30.6745L50.1855 31.7899C50.1855 31.7899 60.7193 30.332 60.649 19.5205L58.8568 19.5557Z",
    fill: "url(#paint79_radial_578_447537)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6488 19.8631C60.6488 23.262 59.2344 26.3359 56.9677 28.5228C53.638 29.9543 49.9833 30.1827 49.9833 30.1827L49.6934 27.9431C57.9253 27.425 60.6313 19.5205 60.6313 19.5205C60.6488 19.6347 60.6488 19.7489 60.6488 19.8631Z",
    fill: "url(#paint80_radial_578_447537)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7742 19.5205C56.7742 19.5205 58.1711 23.9207 53.8223 27.9783C53.8223 27.9783 58.8476 25.6508 60.6574 19.5205C60.6486 19.5205 60.2884 19.5908 56.7742 19.5205Z",
    fill: "url(#paint81_radial_578_447537)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7744 19.5205L56.7832 19.8631H60.6488V19.5205H56.7744Z",
    fill: "url(#paint82_radial_578_447537)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7832 19.8632H60.6488V19.7314H56.7744L56.7832 19.8632Z",
    fill: "url(#paint83_radial_578_447537)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.783 19.863C56.783 19.863 56.906 23.5781 53.8311 26.1163C53.8311 26.1163 56.6336 24.3159 57.0553 20.1265H60.4553C60.4553 20.1265 60.6047 23.7976 58.5225 26.7223C58.5225 26.7223 60.5607 24.4388 60.6398 19.8718H56.783V19.863Z",
    fill: "url(#paint84_radial_578_447537)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9263 23.2881C35.9263 23.2881 14.3931 17.3774 12.636 13.8467C10.8789 10.3161 11.0019 8.18188 11.0019 8.18188C11.0019 8.18188 32.0255 20.5128 37.3144 20.2581C37.3144 20.2757 38.5707 23.1652 35.9263 23.2881Z",
    fill: "url(#paint85_radial_578_447537)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8924 22.1113C15.1136 22.8666 17.1694 23.3057 18.9528 23.7624C20.1125 24.0523 21.1404 24.3509 21.7378 24.7461C21.7378 24.7461 21.3337 20.0298 19.4448 19.3974C19.436 19.3974 19.4273 19.3886 19.4097 19.3886C19.1549 19.3008 18.865 19.2042 18.5399 19.09C17.9249 18.8793 17.1957 18.6158 16.4578 18.326C14.6655 17.6146 12.803 16.7363 12.1968 15.9458C12.1968 15.9283 11.8805 20.8466 13.8924 22.1113Z",
    fill: "url(#paint86_radial_578_447537)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4452 19.3885C19.4101 19.3709 19.3662 19.3534 19.3047 19.327C19.3486 19.3446 19.3837 19.3622 19.4101 19.3797C19.4891 19.4236 19.4979 19.4236 19.4452 19.3885Z",
    fill: "url(#paint87_radial_578_447537)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1967 15.928C13.0489 17.0522 16.4137 18.3432 18.531 19.081C18.8561 19.1951 19.1548 19.2918 19.4008 19.3796C19.4096 19.3796 19.4183 19.3883 19.4359 19.3883C19.638 19.4498 19.8225 19.564 19.9806 19.7133C19.8928 19.6606 19.7961 19.6167 19.6907 19.5904C19.6819 19.5904 19.6731 19.5816 19.6555 19.5816C19.4008 19.5025 19.1109 19.4147 18.7858 19.3093C16.6597 18.633 13.3037 17.4562 12.4515 16.4374C12.4515 16.4374 12.1352 20.9253 14.1471 22.0759C16.0447 23.1561 19.963 23.5162 21.685 24.3154C21.7201 24.5877 21.7377 24.7546 21.7377 24.7546C20.2266 23.7446 15.9129 23.3757 13.9011 22.1286C11.8804 20.8463 12.1967 15.928 12.1967 15.928Z",
    fill: "url(#paint88_radial_578_447537)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4008 19.8013C19.4008 19.8013 16.7124 18.9142 15.5352 18.4224C15.5352 18.4224 17.1341 20.2228 18.2587 22.9894C18.2587 22.9894 20.5253 23.4461 21.3248 23.9555C21.3248 23.9555 20.8679 20.5566 19.4008 19.8013Z",
    fill: "url(#paint89_radial_578_447537)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9238 24.834C16.9238 24.834 16.959 25.0009 17.038 25.2819C17.3016 26.2656 18.0747 28.5666 19.5858 29.0585C20.4292 29.3307 21.6153 29.4625 22.854 29.6293C24.4618 29.8401 26.1662 30.1212 27.4049 30.8589C27.4049 30.8589 27.1062 29.4098 25.9465 28.0924C25.3579 27.4337 24.5496 26.8013 23.4514 26.4061C22.2566 25.9758 21.0618 25.6508 20.0339 25.4137C18.2329 25.0009 16.9238 24.834 16.9238 24.834Z",
    fill: "url(#paint90_radial_578_447537)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9238 24.834C17.0644 24.8515 20.2272 25.2644 23.4427 26.4061C24.5496 26.7926 25.3491 27.4337 25.9377 28.0924C25.1031 27.3546 22.8013 25.8528 17.4158 25.317C17.7584 26.4236 18.514 28.2505 19.8406 28.6808C21.6416 29.2693 24.9889 29.1902 27.2204 30.2353C27.361 30.613 27.4049 30.8501 27.4049 30.8501C25.1997 29.5415 21.5186 29.682 19.577 29.0497C18.0659 28.5578 17.3016 26.2568 17.0293 25.2731C16.959 25.0009 16.9238 24.834 16.9238 24.834Z",
    fill: "url(#paint91_radial_578_447537)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3721 26.8187C23.3721 26.8187 25.3224 27.4862 26.6754 29.7785C26.6754 29.7785 26.2713 29.515 24.725 29.2428C24.7338 29.2515 23.7498 27.091 23.3721 26.8187Z",
    fill: "url(#paint92_radial_578_447537)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1855 30.4988C22.1855 30.4988 22.2031 30.5866 22.247 30.7359C22.4052 31.3068 22.8972 32.7296 23.8987 33.1863C24.5049 33.4673 25.5855 33.4234 26.7452 33.3444C26.7804 33.3444 26.8067 33.3356 26.8418 33.3356C28.0718 33.239 29.3721 33.0985 30.2418 33.239C30.2418 33.239 30.1803 33.1863 30.0485 33.0985C29.4951 32.7208 27.7995 31.6405 25.2868 30.9994C24.8651 30.8852 24.4258 30.7886 23.9514 30.7096C23.3892 30.613 22.8005 30.5339 22.1855 30.4988Z",
    fill: "url(#paint93_radial_578_447537)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1855 30.4988C22.3261 30.5076 22.4755 30.5164 22.616 30.5339C22.6248 30.5339 22.6248 30.5339 22.6336 30.5339C26.5871 30.894 29.3194 32.5979 30.0398 33.1073C29.9431 33.0458 26.8419 31.2541 22.7039 30.7886C22.9147 31.4737 23.354 32.4749 24.1359 32.8877C25.2692 33.4761 28.2475 32.9404 30.0398 33.1161C30.1628 33.2039 30.233 33.2566 30.233 33.2566C28.5287 32.9843 25.1463 33.7923 23.8899 33.2127C22.8884 32.756 22.4052 31.3244 22.2383 30.7623C22.2031 30.5866 22.1855 30.4988 22.1855 30.4988Z",
    fill: "url(#paint94_radial_578_447537)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8389 31.2455C24.8389 31.2455 25.2079 31.8339 25.5856 33.002C25.5856 33.002 28.0104 32.7913 29.0559 32.9494C29.0559 32.9494 27.2988 31.6671 24.8389 31.2455Z",
    fill: "url(#paint95_radial_578_447537)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5371 28.2505C27.5371 28.2505 27.5547 28.3734 27.5986 28.5842C27.7919 29.4098 28.5035 31.5528 30.5945 32.3959C31.2446 32.6594 32.9402 33.0809 34.3898 33.0458C35.444 33.0195 36.3665 32.7472 36.6652 31.9919C36.6652 31.9919 36.6301 31.4562 35.9272 30.7799C35.2683 30.1387 33.9944 29.3746 31.596 28.8301C30.5154 28.5754 29.1712 28.3734 27.5371 28.2505Z",
    fill: "url(#paint96_radial_578_447537)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M27.581 28.4701C27.581 28.4613 27.5722 28.4525 27.5722 28.4349C27.5722 28.4349 27.5722 28.4349 27.5722 28.4261C27.5459 28.312 27.5371 28.2417 27.5371 28.2417C27.6689 28.2505 27.8007 28.2593 27.9237 28.2768C32.8347 28.6984 34.996 29.8577 35.936 30.7623C35.3386 30.3759 32.536 28.6984 27.9939 28.5842C28.2224 29.4713 28.9516 31.4825 30.9634 32.2817C31.7541 32.5979 34.0999 33.1688 35.6637 32.835C34.135 33.3532 31.4642 32.7209 30.6032 32.3783C28.5123 31.544 27.8095 29.3922 27.6074 28.5666C27.5986 28.5403 27.5898 28.5052 27.581 28.4701Z",
    fill: "url(#paint97_radial_578_447537)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0918 28.8563C29.0918 28.8563 30.6732 31.7019 30.7962 32.0444C30.7962 32.0444 33.3264 32.7383 34.3631 32.6768C34.3631 32.6768 33.098 30.0244 32.2809 29.5238L29.0918 28.8563Z",
    fill: "url(#paint98_radial_578_447537)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0865 26.9592C28.5728 27.5476 30.611 27.6442 32.3945 28.0658C33.7826 28.3908 35.0213 28.9265 36.1898 30.0331C36.1898 30.0331 36.7872 25.0973 35.8911 23.9028C35.7769 23.8853 31.1206 23.0157 27.2286 22.0321C24.8741 21.4436 22.8095 20.8113 22.1945 20.3107C22.1945 20.3107 22.1857 20.4863 22.1769 20.7762C22.1682 22.1287 22.4493 26.0897 26.0865 26.9592Z",
    fill: "url(#paint99_radial_578_447537)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1942 20.2932C22.2205 20.3108 22.2557 20.3371 22.282 20.3635C22.2908 20.3635 22.2908 20.3722 22.2908 20.3722C22.3259 20.3898 22.3523 20.4074 22.3874 20.4337C22.3874 20.4337 22.3962 20.4337 22.3962 20.4425C22.4753 20.4864 22.5631 20.5391 22.6686 20.583C25.4184 21.9268 35.7062 23.8502 35.8819 23.8765C32.315 23.5779 24.9528 21.5491 22.6774 20.8992C22.7389 22.5328 23.2836 25.8614 26.5781 26.6431C30.76 27.6355 33.6592 27.2227 36.2421 29.3306C36.207 29.7522 36.1719 30.0156 36.1719 30.0156C33.4747 27.4686 30.4876 27.9956 26.0686 26.9417C21.6495 25.8878 22.1942 20.2932 22.1942 20.2932Z",
    fill: "url(#paint100_radial_578_447537)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6104 21.7247C24.6104 21.7247 26.4114 25.3256 26.7277 26.4323C26.7277 26.4323 28.555 26.9065 30.1013 27.0646C30.1013 27.0646 28.1685 23.5252 27.7643 22.6733C27.7731 22.6733 25.2341 22.1639 24.6104 21.7247Z",
    fill: "url(#paint101_radial_578_447537)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9824 34.1436C26.9824 34.1436 27.0439 34.2489 27.1406 34.407C27.4041 34.8023 27.9752 35.54 28.6253 35.6454C29.0822 35.7244 29.9783 35.6806 30.7426 35.6191C31.463 35.5576 32.0692 35.4873 32.0692 35.4873C32.0692 35.4873 32.5173 34.5915 31.6914 34.2929C31.5421 34.2402 29.3896 34.1963 28.0455 34.1699C27.4305 34.1524 26.9824 34.1436 26.9824 34.1436Z",
    fill: "url(#paint102_radial_578_447537)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9824 34.1437C26.9824 34.1437 26.9912 34.1437 26.9824 34.1437C26.9824 34.1349 26.9912 34.1349 26.9824 34.1437C26.9824 34.1349 27.1318 34.1437 27.369 34.1437C27.369 34.1437 27.369 34.1437 27.369 34.1525C28.476 34.17 31.5157 34.2227 31.6827 34.293L27.5183 34.3984C27.7995 34.8024 28.23 35.2855 28.722 35.4084C29.5039 35.5841 31.5948 35.4962 32.0692 35.4699C32.0604 35.4874 32.0604 35.505 32.0604 35.505C32.0604 35.505 29.5126 35.8036 28.6165 35.6543C27.9664 35.5401 27.4041 34.82 27.1318 34.4247H27.123C27.0439 34.2491 26.9824 34.1437 26.9824 34.1437Z",
    fill: "url(#paint103_radial_578_447537)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6885 34.4158C29.6885 34.4158 29.8466 34.5036 29.9081 34.5739C30.0838 34.732 30.242 35.0657 30.3474 35.4346L31.9463 35.3555C31.9463 35.3555 32.1572 34.732 31.5159 34.4773C30.9975 34.2577 29.6885 34.4158 29.6885 34.4158Z",
    fill: "url(#paint104_radial_578_447537)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0019 8.1908C11.0019 8.1908 26.6136 17.114 31.9289 18.8266C31.9289 18.8266 27.1056 17.4653 11.5641 8.83196C11.6783 9.76292 12.0385 11.4316 13.1455 13.6536C14.9026 17.1755 36.4358 23.095 36.4358 23.095C36.6291 23.0862 36.8048 23.0599 36.9629 23.0248C36.7169 23.1741 36.3743 23.2794 35.9263 23.297C35.9263 23.297 14.3931 17.3863 12.636 13.8556C10.8789 10.325 11.0019 8.1908 11.0019 8.1908Z",
    fill: "url(#paint105_radial_578_447537)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0332 13.7327C20.0332 13.7327 23.6792 15.6298 24.3029 15.8669C24.3029 15.8669 25.8053 19.1165 27.4042 20.0387L23.0378 18.37C23.0378 18.37 21.6322 14.9447 20.0332 13.7327Z",
    fill: "url(#paint106_radial_578_447537)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7374 28.5224C40.9689 29.7871 43.5782 30.5513 45.0717 29.3744C45.3528 29.1636 45.5812 28.8737 45.7833 28.5224L44.1053 23.4197C44.1053 23.4197 40.4945 22.278 39.6159 16.7361C39.6159 16.7361 36.6201 13.8378 31.5157 12.6873C31.5157 12.6785 29.1788 23.1123 38.7374 28.5224Z",
    fill: "url(#paint107_linear_578_447537)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5156 12.6786C36.2861 14.479 39.0799 16.7625 39.0799 16.7625C39.5631 22.0848 43.6747 23.938 43.6747 23.938L45.0716 29.3745C45.3527 29.1637 45.5812 28.8739 45.7832 28.5225L44.1052 23.4198C44.1052 23.4198 40.4944 22.2781 39.6158 16.7362C39.6158 16.7274 36.62 13.8291 31.5156 12.6786Z",
    fill: "url(#paint108_radial_578_447537)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0716 29.3745L43.6747 23.938C43.6747 23.938 39.484 22.0058 39.0799 16.7625C39.0799 16.7625 34.8365 13.6008 31.5156 12.6786C31.5156 12.6786 38.1135 15.7965 38.6758 16.9997C38.6758 16.9997 38.7549 21.593 43.1915 24.0961C43.1915 24.0961 44.852 28.6104 45.0716 29.3745Z",
    fill: "url(#paint109_radial_578_447537)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M44.887 30.7007C44.887 30.7007 39.1589 21.9092 32.1481 20.5391C32.1481 20.5391 30.5843 16.6308 31.5331 12.7225C31.5331 12.7225 34.485 20.6182 43.3584 24.8163C43.3496 24.8251 43.0245 27.4863 44.887 30.7007Z",
    fill: "url(#paint110_radial_578_447537)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3135 12.8629C31.3135 12.8629 28.9766 25.7647 44.0524 31.5612C44.0524 31.5612 29.7058 28.338 31.3135 12.8629Z",
    fill: "url(#paint111_radial_578_447537)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0331 15.9457C37.0331 15.9457 34.0724 13.8203 32.0781 13.2582C32.0781 13.2582 34.7665 18.6244 38.9308 21.6369C38.9396 21.6456 37.9644 20.0209 37.0331 15.9457Z",
    fill: "url(#paint112_radial_578_447537)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5572 30.4372C46.5572 30.4372 44.0885 20.1439 31.1475 20.1439L31.411 27.539C31.411 27.539 39.8627 28.6807 39.4234 31.2365L46.5572 30.4372Z",
    fill: "url(#paint113_radial_578_447537)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1562 20.1352L31.411 27.5302L32.0084 27.5126L31.7537 20.0649L31.1562 20.1352Z",
    fill: "url(#paint114_radial_578_447537)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7539 20.0649C31.7539 20.0649 39.4763 22.2782 41.5234 30.9204C41.5234 30.9204 37.0779 26.7837 32.1493 27.4863L31.7539 20.0649Z",
    fill: "url(#paint115_radial_578_447537)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5574 30.4373C46.5574 30.4373 44.3699 23.1301 31.9384 22.893L31.7627 20.0649C31.7539 20.0649 43.544 20.1089 46.5574 30.4373Z",
    fill: "url(#paint116_radial_578_447537)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3418 27.5126C32.3418 27.5126 40.3542 24.992 46.5567 30.4372L39.4229 31.2277C39.4229 31.2277 40.4069 28.9354 32.3418 27.5126Z",
    fill: "url(#paint117_radial_578_447537)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4727 20.1528L31.6571 27.4951L32.0086 27.5126L31.7538 20.0649L31.4727 20.1528Z",
    fill: "url(#paint118_radial_578_447537)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5047 30.3231C46.5047 30.3231 43.0872 20.3547 31.71 20.0298C31.71 20.0298 43.1047 19.7048 46.5047 30.3231Z",
    fill: "url(#paint119_radial_578_447537)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4235 31.2277C39.4235 31.2277 40.4075 28.8739 31.4111 27.5302C31.4111 27.5302 40.2318 28.3821 39.4235 31.2277Z",
    fill: "url(#paint120_radial_578_447537)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M34.0986 19.8629C34.0986 23.2618 35.5131 26.3357 37.7797 28.5226C39.5896 30.2704 41.9441 31.4473 44.5621 31.7898L45.0366 27.943C43.2707 27.7058 41.6366 26.9066 40.3539 25.6243C38.8164 24.0873 37.9642 22.0322 37.9642 19.8541C37.9642 19.7399 37.9642 19.6258 37.973 19.5116H34.1074C34.0986 19.6346 34.0986 19.7487 34.0986 19.8629Z",
    fill: "#D7FEFF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8912 19.5554C35.8912 19.5554 35.9879 29.067 44.6679 30.6743L44.5625 31.7897C44.5625 31.7897 34.0287 30.3318 34.099 19.5203L35.8912 19.5554Z",
    fill: "url(#paint121_radial_578_447537)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0986 19.8628C34.0986 23.2617 35.5131 26.3356 37.7797 28.5225C41.1094 29.9541 44.7642 30.1825 44.7642 30.1825L45.0541 27.9429C36.8221 27.4247 34.1162 19.5203 34.1162 19.5203C34.0986 19.6344 34.0986 19.7486 34.0986 19.8628Z",
    fill: "url(#paint122_radial_578_447537)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M37.973 19.5203C37.973 19.5203 36.5761 23.9204 40.9249 27.978C40.9249 27.978 35.8997 25.6506 34.0898 19.5203C34.1074 19.5203 34.4676 19.5905 37.973 19.5203Z",
    fill: "url(#paint123_radial_578_447537)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M37.973 19.5203V19.8628H34.0986L34.1074 19.5203H37.973Z",
    fill: "url(#paint124_radial_578_447537)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M37.973 19.8629H34.0986L34.1074 19.7312H37.973V19.8629Z",
    fill: "url(#paint125_radial_578_447537)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M37.973 19.8628C37.973 19.8628 37.85 23.5778 40.925 26.116C40.925 26.116 38.1224 24.3156 37.7007 20.1263H34.3007C34.3007 20.1263 34.1514 23.7974 36.2335 26.722C36.2335 26.722 34.1953 24.4385 34.1162 19.8715H37.973V19.8628Z",
    fill: "url(#paint126_radial_578_447537)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M57.873 30.3406C58.0575 30.3406 62.3273 30.9027 62.3273 30.9027L60.8425 33.5638L62.2658 36.8398L57.8115 36.5939L57.873 30.3406Z",
    fill: "url(#paint127_radial_578_447537)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6038 36.1107L57.8115 36.5938L57.8203 35.9702C57.8203 35.9702 58.734 35.7858 59.6038 36.1107Z",
    fill: "url(#paint128_radial_578_447537)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3274 30.8939L60.4385 33.5814L62.2659 36.8398L60.8426 33.5639L62.3274 30.8939Z",
    fill: "url(#paint129_radial_578_447537)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4792 36.5236L59.595 36.1108L59.1381 36.0845L57.8027 36.5939L62.257 36.8398C61.5981 36.5939 58.4792 36.5236 58.4792 36.5236Z",
    fill: "url(#paint130_radial_578_447537)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8839 30.3405C36.6994 30.3405 32.4297 30.9025 32.4297 30.9025L33.9144 33.5637L32.4912 36.8396L36.9454 36.5937L36.8839 30.3405Z",
    fill: "url(#paint131_radial_578_447537)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1533 36.1107L36.9456 36.5938L36.9368 35.9702C36.928 35.9702 36.0143 35.7858 35.1533 36.1107Z",
    fill: "url(#paint132_radial_578_447537)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4297 30.8939L34.3186 33.5814L32.4824 36.8398L33.9144 33.5639L32.4297 30.8939Z",
    fill: "url(#paint133_radial_578_447537)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M36.269 36.5236L35.1532 36.1108L35.6101 36.0845L36.9454 36.5939L32.4912 36.8398C33.1501 36.5939 36.269 36.5236 36.269 36.5236Z",
    fill: "url(#paint134_radial_578_447537)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6033 30.2525V36.1106C59.6033 36.1106 54.8943 35.6538 47.4179 35.6538C41.3559 35.6538 37.4024 35.9261 35.9089 36.0579C35.4608 36.093 35.2324 36.1193 35.2324 36.1193V30.2613C35.2324 30.2613 35.4433 30.2262 35.9089 30.1822C35.9177 30.1822 35.9177 30.1822 35.9177 30.1822C37.2531 30.0505 40.697 29.7958 47.4179 29.7958C52.7067 29.7958 56.3263 29.9978 58.1713 30.1295C58.4085 30.1471 58.6194 30.1647 58.8038 30.1822C59.331 30.2262 59.6033 30.2525 59.6033 30.2525Z",
    fill: "url(#paint135_radial_578_447537)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9001 30.1735V36.0491C35.4521 36.0842 35.2236 36.1106 35.2236 36.1106V30.2525C35.2236 30.2525 35.4345 30.2262 35.9001 30.1735Z",
    fill: "url(#paint136_radial_578_447537)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9268 30.1735V36.0491C59.3748 36.0842 59.6032 36.1106 59.6032 36.1106V30.2525C59.6032 30.2525 59.3924 30.2262 58.9268 30.1735Z",
    fill: "url(#paint137_radial_578_447537)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9001 35.7595C35.4521 35.7946 35.2236 35.8209 35.2236 35.8209V36.1108C35.2236 36.1108 35.4521 36.0844 35.9001 36.0493C37.4024 35.9263 41.3559 35.6453 47.4091 35.6453C54.8855 35.6453 59.5945 36.102 59.5945 36.102V35.8121C59.5945 35.8121 54.8855 35.3555 47.4091 35.3555C41.3559 35.3555 37.4024 35.6365 35.9001 35.7595Z",
    fill: "url(#paint138_radial_578_447537)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7953 30.1735C44.6859 30.5073 35.9004 35.7593 35.9004 35.7593V30.1735C37.2358 30.0418 40.6709 29.7871 47.4094 29.7871C53.3923 29.7871 57.2315 30.0506 58.7953 30.1735Z",
    fill: "url(#paint139_radial_578_447537)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9004 30.1735C50.0099 30.5073 58.7953 35.7593 58.7953 35.7593V30.1735C57.4599 30.0418 54.0248 29.7871 47.2864 29.7871C41.3122 29.7871 37.4642 30.0506 35.9004 30.1735Z",
    fill: "url(#paint140_radial_578_447537)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1628 30.1296C53.9282 29.9188 35.9004 30.1823 35.9004 30.1823C35.9092 30.1823 35.9092 30.1735 35.9092 30.1735C37.2446 30.0418 40.6885 29.7871 47.4094 29.7871C52.707 29.7871 56.3178 29.9891 58.1628 30.1296Z",
    fill: "url(#paint141_radial_578_447537)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7427 38.1133V38.3153C64.7427 38.3153 59.0145 38.9477 58.382 41.9601C58.382 41.9601 55.2104 43.9011 51.4239 47.9763C50.1236 49.3815 48.7531 51.0238 47.4177 52.9385V53C47.4089 52.9912 47.4089 52.9824 47.4001 52.9736C47.3914 52.9824 47.3914 52.9912 47.3826 53V52.9385C42.1376 45.4556 36.4183 41.9514 36.4183 41.9514C35.7857 38.9389 30.0576 38.3065 30.0576 38.3065V38.1045L30.3915 38.1396C30.4266 38.1221 30.4705 38.1045 30.5057 38.087C34.8457 36.1548 41.6544 37.0067 41.6544 37.0067C42.1289 38.7632 44.3077 41.4419 44.3077 41.4419L47.4089 43.2688L50.5102 41.4419C50.5102 41.4419 52.689 38.7632 53.1634 37.0067C53.1634 37.0067 60.0952 36.1372 64.4264 38.1396L64.7427 38.1133Z",
    fill: "url(#paint142_radial_578_447537)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3823 41.96C58.3823 41.96 55.2108 43.901 51.4242 47.9761L49.9834 46.1757L52.1271 43.2599L58.3823 41.2047C58.3823 41.2047 58.3472 41.758 58.3823 41.96Z",
    fill: "url(#paint143_radial_578_447537)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4086 50.5232V52.9385L47.3735 52.9912V52.9385C42.1285 45.4556 36.4092 41.9514 36.4092 41.9514V41.196L43.8768 43.2424L47.4086 50.5232Z",
    fill: "url(#paint144_radial_578_447537)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4095 41.2049V41.9601C35.777 38.9477 30.0488 38.3153 30.0488 38.3153V38.1133C30.0488 38.1133 30.2157 38.1045 30.4969 38.1045C31.7532 38.0782 35.1971 37.9904 35.2674 38.0167C35.3553 38.0343 36.4095 41.2049 36.4095 41.2049Z",
    fill: "url(#paint145_radial_578_447537)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1458 37.0155C52.6714 38.4998 50.4926 40.7833 50.4926 40.7833L47.3914 42.3379L44.2901 40.7833C44.2901 40.7833 42.1113 38.5086 41.6369 37.0155C41.6369 37.0155 34.3449 36.2339 30.04 38.1134C30.04 38.1134 35.7682 38.6491 36.4007 41.2136C36.4007 41.2136 42.1201 44.1822 47.365 50.5321V50.5848C47.3738 50.576 47.3738 50.5672 47.3826 50.5585C47.3913 50.5672 47.3913 50.576 47.4001 50.5848V50.5321C52.6451 44.1734 58.3644 41.2136 58.3644 41.2136C58.997 38.6579 64.7251 38.1134 64.7251 38.1134C60.4378 36.2339 53.1458 37.0155 53.1458 37.0155Z",
    fill: "url(#paint146_radial_578_447537)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7075 38.1134C64.7075 38.1134 58.9794 38.6491 58.3468 41.2136C58.3468 41.2136 52.6275 44.1822 47.3826 50.5321V50.5848C47.3738 50.576 47.3738 50.5672 47.365 50.5585C47.3562 50.5672 47.3562 50.576 47.3474 50.5848V50.5321C42.1025 44.1734 36.3831 41.2136 36.3831 41.2136C35.7506 38.6579 30.0225 38.1134 30.0225 38.1134C34.3273 36.2339 41.6193 37.0155 41.6193 37.0155C42.0937 38.4998 44.2725 40.7833 44.2725 40.7833L47.3738 42.3379L50.475 40.7833C50.475 40.7833 52.6538 38.5086 53.1283 37.0155C53.1283 37.0155 53.1283 37.0155 53.137 37.0155H53.1458H53.1546C53.1634 37.0155 53.1634 37.0155 53.1634 37.0155C53.1722 37.0155 53.181 37.0155 53.1898 37.0155C53.2073 37.0155 53.2249 37.0067 53.2513 37.0067H53.26C53.383 36.998 53.5851 36.9804 53.8575 36.9628C53.875 36.9628 53.8926 36.9628 53.9102 36.954C53.9365 36.954 53.9629 36.9453 53.9892 36.9453C54.0156 36.9453 54.0507 36.9365 54.0771 36.9365C56.168 36.8048 61.3515 36.6467 64.7075 38.1134Z",
    fill: "url(#paint147_radial_578_447537)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7076 38.1133C60.3675 36.7608 55.9397 36.8311 54.0596 36.9364C56.1681 36.8047 61.3515 36.6466 64.7076 38.1133Z",
    fill: "url(#paint148_radial_578_447537)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0664 38.1133C34.4064 36.7608 38.8343 36.8311 40.7144 36.9364C38.6059 36.8047 33.4312 36.6466 30.0664 38.1133Z",
    fill: "url(#paint149_radial_578_447537)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3468 40.4846C58.3468 40.4846 52.6275 43.4532 47.3826 49.8031V49.8558C47.3738 49.847 47.3738 49.8382 47.365 49.8294C47.3562 49.8382 47.3562 49.847 47.3474 49.8558V49.8031C42.0937 43.4532 36.3744 40.4846 36.3744 40.4846C35.9526 38.7808 33.2555 37.9728 31.5072 37.6215C30.9801 37.762 30.4705 37.9376 30.0049 38.1484C30.0049 38.1484 35.733 38.6842 36.3656 41.2487C36.3656 41.2487 42.0849 44.2172 47.3298 50.5671V50.6198C47.3386 50.6111 47.3386 50.6023 47.3474 50.5935C47.3562 50.6023 47.3562 50.6111 47.365 50.6198V50.5671C52.6099 44.2085 58.3293 41.2487 58.3293 41.2487C58.9618 38.693 64.6899 38.1484 64.6899 38.1484C64.2243 37.9464 63.7148 37.7708 63.1876 37.6215C61.4657 37.9728 58.7685 38.7808 58.3468 40.4846Z",
    fill: "url(#paint150_radial_578_447537)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4397 40.7831L47.3473 42.3289L44.2548 40.7831C44.2548 40.7831 42.076 38.5084 41.6016 37.0154C41.6016 37.0154 41.8651 39.4921 43.8506 41.0554L47.3297 42.8734V42.8822L47.3385 42.8734L47.3473 42.8822V42.8734L50.8263 41.0554C52.803 39.4921 53.0754 37.0154 53.0754 37.0154C52.6098 38.5084 50.4397 40.7831 50.4397 40.7831Z",
    fill: "url(#paint151_radial_578_447537)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3232 46.2725C43.3232 46.2725 46.1961 49.0917 47.2328 50.6111L47.4085 52.9385C47.4085 52.9385 47.3646 50.8395 47.4436 50.5584C47.4436 50.5584 49.5346 48.0641 50.8875 46.7467C50.8875 46.7467 47.6721 50.0139 47.3558 50.4354C47.3558 50.4354 44.6411 47.3439 43.3232 46.2725Z",
    fill: "url(#paint152_radial_578_447537)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9277 44.2173C53.9277 44.2173 57.4244 41.6703 58.2326 41.3893L58.3732 41.9602L58.3644 41.2224C58.3644 41.2224 58.8125 40.2651 59.4714 39.7294C59.4714 39.7294 58.505 40.3003 58.2678 41.161C58.2678 41.1698 57.0378 41.7055 53.9277 44.2173Z",
    fill: "url(#paint153_radial_578_447537)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M40.82 44.2173C40.82 44.2173 37.3234 41.6703 36.5151 41.3893L36.3746 41.9602L36.3833 41.2224C36.3833 41.2224 35.9353 40.2651 35.2764 39.7294C35.2764 39.7294 36.2428 40.3003 36.48 41.161C36.48 41.1698 37.7275 41.7055 40.82 44.2173Z",
    fill: "url(#paint154_radial_578_447537)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3379 3L47.3823 8.55942L53.4179 3L47.8567 9.03368L53.4179 15.0762L47.3823 9.50794L41.3379 15.0762L46.9079 9.03368L41.3379 3Z",
    fill: "url(#paint155_radial_578_447537)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8656 39.2451C53.8306 39.2962 53.8307 39.3635 53.8657 39.4146C54.0262 39.6487 54.2042 39.8733 54.3956 40.0845C54.4069 40.0957 54.4182 40.1126 54.4351 40.1239C54.4972 40.1915 54.5649 40.259 54.6327 40.3266C54.7907 40.4843 54.9487 40.6307 55.1236 40.7659C55.2613 40.8796 55.4031 40.9853 55.5521 41.0865C55.6034 41.1213 55.6707 41.1211 55.7212 41.085C55.9933 40.8903 56.3841 40.5544 56.7156 40.2186C56.9908 39.9398 57.2713 39.577 57.3948 39.4123C57.4342 39.3598 57.435 39.2883 57.3971 39.2346C57.328 39.1367 57.217 38.9818 57.1439 38.8907C56.9859 38.6936 56.8166 38.5021 56.6417 38.3219C56.5457 38.2262 56.4498 38.1361 56.3482 38.046C56.1486 37.8717 55.9402 37.7106 55.7229 37.5589C55.6713 37.5228 55.6028 37.5225 55.5508 37.5579C55.3951 37.6642 55.244 37.775 55.1011 37.8939C54.9374 38.0291 54.785 38.1699 54.6383 38.3163C54.3472 38.6119 54.0896 38.9171 53.8656 39.2451Z",
    fill: "#043481"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2767 39.3279C54.407 39.5251 54.5541 39.714 54.7139 39.8902C54.7223 39.8986 54.7307 39.9112 54.7433 39.9196C54.7895 39.9699 54.84 40.0203 54.8904 40.0706C55.0081 40.1881 55.1258 40.2972 55.256 40.398C55.3779 40.4987 55.504 40.591 55.6385 40.6791C55.8403 40.5448 56.0294 40.3979 56.2101 40.2385C56.5001 39.9783 56.7565 39.6846 56.9751 39.3573C56.9835 39.3447 56.9919 39.3363 56.9961 39.3237C56.9204 39.2146 56.8448 39.1055 56.7607 39.0006C56.643 38.8537 56.517 38.711 56.3867 38.5768C56.3152 38.5054 56.2438 38.4383 56.1681 38.3711C56 38.2243 55.8235 38.09 55.6385 37.9641C55.4998 38.0564 55.3653 38.1529 55.2392 38.2579C55.1174 38.3586 55.0039 38.4635 54.8946 38.5726C54.6592 38.8118 54.4533 39.0593 54.2767 39.3279Z",
    fill: "url(#paint156_radial_578_447537)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2762 39.3281H55.6338V37.9769C55.3648 38.1532 55.1126 38.3588 54.8857 38.5854C54.6587 38.812 54.4527 39.0596 54.2762 39.3281Z",
    fill: "url(#paint157_radial_578_447537)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6346 37.9769V39.3323H56.9922C56.8157 39.0638 56.6097 38.812 56.3828 38.5854C56.1516 38.3588 55.9036 38.1532 55.6346 37.9769Z",
    fill: "url(#paint158_radial_578_447537)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6346 39.3281V40.6835C56.1726 40.3268 56.6349 39.8652 56.9922 39.3281H55.6346Z",
    fill: "url(#paint159_radial_578_447537)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2762 39.3281C54.4527 39.5967 54.6587 39.8485 54.8857 40.0751C55.1126 40.3017 55.3648 40.5073 55.6338 40.6835V39.3281H54.2762Z",
    fill: "url(#paint160_radial_578_447537)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2764 39.3278C54.4529 39.5964 54.6589 39.8482 54.8858 40.0748C55.1128 40.3014 55.365 40.507 55.634 40.6832C55.8357 40.549 55.9072 40.5028 56.0879 40.3433L55.2347 38.2704C55.1128 38.3711 54.9993 38.476 54.89 38.5851C54.6589 38.8117 54.4529 39.0593 54.2764 39.3278Z",
    fill: "url(#paint161_radial_578_447537)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7389 39.9235C54.7851 39.9739 54.8356 40.0242 54.886 40.0746C55.113 40.3012 55.3652 40.5068 55.6341 40.683C55.8359 40.5488 56.025 40.4019 56.2058 40.2424C56.4958 39.9823 56.7521 39.6885 56.9707 39.3612C56.4033 39.5291 55.5711 39.7599 54.7389 39.9235Z",
    fill: "url(#paint162_radial_578_447537)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7129 39.8902C54.7213 39.8986 54.7298 39.9112 54.7424 39.9196C54.7886 39.97 54.839 40.0203 54.8895 40.0707C55.0072 40.1882 55.1248 40.2973 55.2551 40.398C55.5746 39.8315 55.9276 39.1517 55.957 38.8873C55.9528 38.8915 55.2467 39.4748 54.7129 39.8902Z",
    fill: "url(#paint163_radial_578_447537)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6337 39.328L56.7559 39.0049C56.6382 38.8581 56.5121 38.7154 56.3818 38.5811C56.3103 38.5098 56.2389 38.4426 56.1632 38.3755L55.6337 39.328Z",
    fill: "url(#paint164_radial_578_447537)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6341 40.2221C55.9871 39.9871 56.2939 39.6849 56.5293 39.3283C56.2939 38.9758 55.9913 38.6694 55.6341 38.4344C55.281 38.6694 54.9742 38.9716 54.7388 39.3283C54.9742 39.6849 55.2768 39.9871 55.6341 40.2221Z",
    fill: "url(#paint165_radial_578_447537)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7558 39.0677C56.6382 38.9209 56.5121 38.7782 56.3818 38.6439C56.3103 38.5726 56.2389 38.5054 56.1632 38.4383C55.9951 38.2914 55.8186 38.1571 55.6336 38.0313C55.4949 38.1236 55.3604 38.2201 55.2344 38.325C55.1125 38.4257 54.999 38.5306 54.8897 38.6397C54.6712 38.8579 54.4736 39.0971 54.3013 39.3531C54.2929 39.3405 54.2887 39.3321 54.2803 39.3195C54.4568 39.0509 54.6627 38.7992 54.8897 38.5726C54.999 38.4635 55.1167 38.3586 55.2344 38.2579C55.3604 38.1529 55.4949 38.0522 55.6336 37.9641C55.8186 38.0858 55.9951 38.2243 56.1632 38.3711C56.2389 38.4383 56.3103 38.5054 56.3818 38.5768C56.5163 38.711 56.6424 38.8495 56.7558 39.0006C56.8399 39.1055 56.9156 39.2146 56.9912 39.3237C56.9828 39.3363 56.9786 39.3447 56.9702 39.3573C56.8987 39.2608 56.8273 39.1642 56.7558 39.0677Z",
    fill: "url(#paint166_radial_578_447537)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7139 39.8274C54.7223 39.8358 54.7307 39.8483 54.7433 39.8567C54.7895 39.9071 54.84 39.9574 54.8904 40.0078C55.0081 40.1253 55.1258 40.2344 55.256 40.3351C55.3779 40.4358 55.504 40.5281 55.6385 40.6163C55.8403 40.482 56.0294 40.3351 56.2101 40.1757C56.5001 39.9155 56.7565 39.6217 56.9751 39.2944C56.9835 39.307 56.9919 39.3154 56.9961 39.328C56.9877 39.3406 56.9793 39.349 56.9751 39.3616C56.7565 39.6847 56.5001 39.9784 56.2101 40.2428C56.0336 40.4023 55.8403 40.5533 55.6385 40.6834C55.5082 40.5953 55.3779 40.503 55.256 40.4022C55.13 40.2973 55.0081 40.1882 54.8904 40.0749C54.84 40.0246 54.7937 39.9742 54.7433 39.9239C54.7349 39.9155 54.7265 39.9029 54.7139 39.8945C54.5541 39.7183 54.4112 39.5294 54.2767 39.3322C54.2852 39.3196 54.2936 39.3112 54.2978 39.2986C54.4239 39.4833 54.5626 39.6595 54.7139 39.8274Z",
    fill: "url(#paint167_radial_578_447537)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3823 38.6438C56.5126 38.7781 56.6387 38.9207 56.7564 39.0676L56.9508 39.3303C56.7376 39.6432 56.4895 39.925 56.2101 40.1756C56.0294 40.335 55.8403 40.4819 55.6385 40.6162C55.504 40.5281 55.3779 40.4357 55.256 40.335C55.1258 40.2343 55.0081 40.1252 54.8904 40.0077C54.84 39.9574 54.7895 39.907 54.7433 39.8567C54.7347 39.8509 54.728 39.8432 54.722 39.8362C54.7192 39.833 54.7165 39.8299 54.7139 39.8273C54.5708 39.6685 54.4389 39.5023 54.3184 39.3285C54.4868 39.0817 54.6786 38.8508 54.8902 38.6396C54.9995 38.5305 55.113 38.4256 55.2349 38.3249C55.361 38.22 55.4955 38.1234 55.6342 38.0311C55.8191 38.157 55.9956 38.2913 56.1637 38.4382C56.2394 38.5053 56.3108 38.5724 56.3823 38.6438ZM54.2832 39.3231C54.2824 39.3219 54.2816 39.3206 54.2808 39.3194C54.4573 39.0508 54.6633 38.799 54.8902 38.5724C54.9995 38.4633 55.1172 38.3584 55.2349 38.2577C55.361 38.1528 55.4955 38.0521 55.6342 37.964C55.8191 38.0857 55.9956 38.2242 56.1637 38.371C56.2394 38.4382 56.3108 38.5053 56.3823 38.5766C56.5168 38.7109 56.6429 38.8494 56.7564 39.0005C56.8336 39.0969 56.9037 39.1968 56.9733 39.297C56.9739 39.2961 56.9745 39.2952 56.9751 39.2944C56.9776 39.2981 56.9801 39.3015 56.9825 39.3047C56.9881 39.3123 56.9931 39.3191 56.9961 39.3279C56.9936 39.3317 56.9911 39.3351 56.9887 39.3383C56.983 39.3459 56.978 39.3527 56.9751 39.3615C56.7565 39.6846 56.5001 39.9783 56.2101 40.2427C56.0336 40.4022 55.8403 40.5532 55.6385 40.6833C55.5082 40.5952 55.3779 40.5029 55.256 40.4022C55.13 40.2973 55.0081 40.1882 54.8904 40.0749C54.8652 40.0497 54.841 40.0245 54.8168 39.9993C54.7927 39.9741 54.7685 39.949 54.7433 39.9238C54.7406 39.9211 54.738 39.9181 54.7352 39.9148C54.7291 39.9079 54.7225 39.9002 54.7139 39.8944C54.5541 39.7182 54.4112 39.5293 54.2767 39.3321C54.2789 39.3289 54.2811 39.3259 54.2832 39.3231Z",
    fill: "url(#paint168_radial_578_447537)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6338 38.4379C55.6338 38.4379 55.1042 38.7694 54.7385 39.3317C54.7385 39.3275 54.9991 38.7484 55.6338 38.4379Z",
    fill: "url(#paint169_radial_578_447537)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5244 39.3284C56.5244 39.3284 56.2092 39.8823 55.6754 40.2138L55.6334 40.6166L55.604 40.2054C55.604 40.2054 55.2047 40.0375 54.7381 39.3284C54.7381 39.3284 55.3266 40.1173 55.6418 40.1592C55.6418 40.1634 56.0074 40.0208 56.5244 39.3284Z",
    fill: "url(#paint170_radial_578_447537)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6299 40.2179C55.6299 40.2179 55.0751 39.9031 54.743 39.3702L54.3396 39.3283L54.7515 39.2989C54.7515 39.2989 54.9196 38.9002 55.6299 38.4344C55.6299 38.4344 54.8397 39.0219 54.7977 39.3366C54.7935 39.3366 54.9364 39.7017 55.6299 40.2179Z",
    fill: "url(#paint171_radial_578_447537)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6511 38.4344C55.6511 38.4344 56.2059 38.7492 56.5379 39.2821L56.9414 39.3241L56.5295 39.3534C56.5295 39.3534 56.3614 39.7521 55.6511 40.2179C55.6511 40.2179 56.4412 39.6304 56.4833 39.3157C56.4875 39.3157 56.3446 38.9506 55.6511 38.4344Z",
    fill: "url(#paint172_radial_578_447537)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7381 39.3235C54.7381 39.3235 55.0534 38.7696 55.5871 38.4381L55.6292 38.0353L55.6586 38.4465C55.6586 38.4465 56.0579 38.6144 56.5244 39.3235C56.5244 39.3235 55.936 38.5346 55.6208 38.4927C55.6208 38.4885 55.2551 38.6311 54.7381 39.3235Z",
    fill: "url(#paint173_radial_578_447537)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7689 43.0007C49.734 43.0519 49.7341 43.1191 49.7691 43.1702C49.9295 43.4043 50.1075 43.6289 50.299 43.8401C50.3102 43.8514 50.3215 43.8682 50.3385 43.8795C50.4005 43.9471 50.4683 44.0147 50.536 44.0822C50.694 44.2399 50.852 44.3863 51.0269 44.5215C51.1647 44.6352 51.3064 44.7409 51.4555 44.8421C51.5067 44.8769 51.5741 44.8767 51.6245 44.8407C51.8967 44.6459 52.2874 44.31 52.6189 43.9742C52.8941 43.6955 53.1746 43.3326 53.2981 43.168C53.3375 43.1154 53.3383 43.0439 53.3004 42.9902C53.2313 42.8924 53.1203 42.7374 53.0473 42.6463C52.8892 42.4492 52.7199 42.2577 52.545 42.0775C52.4491 41.9818 52.3531 41.8917 52.2515 41.8016C52.0519 41.6273 51.8435 41.4662 51.6263 41.3145C51.5746 41.2784 51.5061 41.2781 51.4541 41.3136C51.2984 41.4198 51.1474 41.5307 51.0044 41.6496C50.8407 41.7847 50.6884 41.9255 50.5416 42.0719C50.2505 42.3675 49.993 42.6728 49.7689 43.0007Z",
    fill: "#043481"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1801 43.0835C50.3104 43.2807 50.4575 43.4696 50.6172 43.6458C50.6256 43.6542 50.634 43.6668 50.6466 43.6752C50.6928 43.7255 50.7433 43.7759 50.7937 43.8263C50.9114 43.9438 51.0291 44.0529 51.1594 44.1536C51.2813 44.2543 51.4073 44.3466 51.5418 44.4347C51.7436 44.3004 51.9327 44.1536 52.1135 43.9941C52.4035 43.7339 52.6598 43.4402 52.8784 43.1129C52.8868 43.1003 52.8952 43.0919 52.8994 43.0793C52.8238 42.9702 52.7481 42.8611 52.664 42.7562C52.5464 42.6093 52.4203 42.4667 52.29 42.3324C52.2185 42.261 52.1471 42.1939 52.0714 42.1268C51.9033 41.9799 51.7268 41.8456 51.5418 41.7197C51.4031 41.812 51.2686 41.9086 51.1426 42.0135C51.0207 42.1142 50.9072 42.2191 50.7979 42.3282C50.5625 42.5674 50.3566 42.815 50.1801 43.0835Z",
    fill: "url(#paint174_radial_578_447537)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1795 43.0837H51.5371V41.7325C51.2681 41.9088 51.0159 42.1144 50.789 42.341C50.562 42.5676 50.3561 42.8152 50.1795 43.0837Z",
    fill: "url(#paint175_radial_578_447537)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5379 41.7325V43.0879H52.8955C52.719 42.8194 52.513 42.5676 52.2861 42.341C52.0549 42.1144 51.8069 41.9088 51.5379 41.7325Z",
    fill: "url(#paint176_radial_578_447537)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5379 43.0837V44.4391C52.0759 44.0825 52.5383 43.6209 52.8955 43.0837H51.5379Z",
    fill: "url(#paint177_radial_578_447537)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1795 43.0837C50.3561 43.3523 50.562 43.6041 50.789 43.8307C51.0159 44.0573 51.2681 44.2629 51.5371 44.4391V43.0837H50.1795Z",
    fill: "url(#paint178_radial_578_447537)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1797 43.0835C50.3562 43.352 50.5622 43.6038 50.7892 43.8304C51.0161 44.057 51.2683 44.2626 51.5373 44.4389C51.739 44.3046 51.8105 44.2584 51.9912 44.099L51.138 42.026C51.0161 42.1267 50.9026 42.2316 50.7934 42.3407C50.5622 42.5673 50.3562 42.8149 50.1797 43.0835Z",
    fill: "url(#paint179_radial_578_447537)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6422 43.6791C50.6885 43.7295 50.7389 43.7798 50.7893 43.8302C51.0163 44.0568 51.2685 44.2624 51.5375 44.4386C51.7392 44.3044 51.9283 44.1575 52.1091 43.998C52.3991 43.7379 52.6555 43.4441 52.874 43.1168C52.3066 43.2847 51.4744 43.5155 50.6422 43.6791Z",
    fill: "url(#paint180_radial_578_447537)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6163 43.6459C50.6247 43.6542 50.6331 43.6668 50.6457 43.6752C50.6919 43.7256 50.7424 43.7759 50.7928 43.8263C50.9105 43.9438 51.0282 44.0529 51.1584 44.1536C51.4779 43.5871 51.8309 42.9073 51.8604 42.6429C51.8561 42.6471 51.15 43.2304 50.6163 43.6459Z",
    fill: "url(#paint181_radial_578_447537)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M51.537 43.0837L52.6592 42.7605C52.5415 42.6137 52.4154 42.471 52.2851 42.3367C52.2137 42.2654 52.1422 42.1982 52.0666 42.1311L51.537 43.0837Z",
    fill: "url(#paint182_radial_578_447537)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5374 43.9777C51.8904 43.7427 52.1972 43.4406 52.4326 43.0839C52.1972 42.7314 51.8946 42.4251 51.5374 42.1901C51.1843 42.4251 50.8775 42.7272 50.6421 43.0839C50.8775 43.4406 51.1801 43.7427 51.5374 43.9777Z",
    fill: "url(#paint183_radial_578_447537)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6592 42.8233C52.5415 42.6765 52.4154 42.5338 52.2851 42.3995C52.2136 42.3282 52.1422 42.261 52.0665 42.1939C51.8984 42.047 51.7219 41.9128 51.537 41.7869C51.3983 41.8792 51.2638 41.9757 51.1377 42.0806C51.0158 42.1813 50.9023 42.2862 50.793 42.3953C50.5745 42.6135 50.3769 42.8527 50.2046 43.1087C50.1962 43.0961 50.192 43.0877 50.1836 43.0751C50.3601 42.8066 50.5661 42.5548 50.793 42.3282C50.9023 42.2191 51.02 42.1142 51.1377 42.0135C51.2638 41.9086 51.3983 41.8078 51.537 41.7197C51.7219 41.8414 51.8984 41.9799 52.0665 42.1268C52.1422 42.1939 52.2136 42.261 52.2851 42.3324C52.4196 42.4667 52.5457 42.6051 52.6592 42.7562C52.7432 42.8611 52.8189 42.9702 52.8945 43.0793C52.8861 43.0919 52.8819 43.1003 52.8735 43.1129C52.8021 43.0164 52.7306 42.9199 52.6592 42.8233Z",
    fill: "url(#paint184_radial_578_447537)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6172 43.583C50.6256 43.5914 50.634 43.604 50.6466 43.6123C50.6928 43.6627 50.7433 43.7131 50.7937 43.7634C50.9114 43.8809 51.0291 43.99 51.1594 44.0907C51.2813 44.1914 51.4073 44.2838 51.5418 44.3719C51.7436 44.2376 51.9327 44.0907 52.1135 43.9313C52.4035 43.6711 52.6598 43.3774 52.8784 43.05C52.8868 43.0626 52.8952 43.071 52.8994 43.0836C52.891 43.0962 52.8826 43.1046 52.8784 43.1172C52.6598 43.4403 52.4035 43.734 52.1135 43.9984C51.9369 44.1579 51.7436 44.3089 51.5418 44.439C51.4116 44.3509 51.2813 44.2586 51.1594 44.1579C51.0333 44.053 50.9114 43.9439 50.7937 43.8306C50.7433 43.7802 50.697 43.7298 50.6466 43.6795C50.6382 43.6711 50.6298 43.6585 50.6172 43.6501C50.4575 43.4739 50.3146 43.285 50.1801 43.0878C50.1885 43.0752 50.1969 43.0668 50.2011 43.0542C50.3272 43.2389 50.4659 43.4151 50.6172 43.583Z",
    fill: "url(#paint185_radial_578_447537)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2856 42.3994C52.4159 42.5337 52.542 42.6764 52.6597 42.8232L52.8542 43.0859C52.641 43.3988 52.3928 43.6806 52.1135 43.9312C51.9327 44.0906 51.7436 44.2375 51.5418 44.3718C51.4073 44.2837 51.2813 44.1914 51.1594 44.0906C51.0291 43.9899 50.9114 43.8808 50.7937 43.7633C50.7433 43.713 50.6928 43.6626 50.6466 43.6123C50.638 43.6065 50.6313 43.5988 50.6253 43.5919C50.6225 43.5886 50.6198 43.5856 50.6172 43.5829C50.4741 43.4241 50.3422 43.2579 50.2217 43.0841C50.3901 42.8374 50.582 42.6064 50.7935 42.3952C50.9028 42.2861 51.0163 42.1812 51.1382 42.0805C51.2643 41.9756 51.3988 41.8791 51.5375 41.7867C51.7224 41.9126 51.8989 42.0469 52.0671 42.1938C52.1427 42.2609 52.2142 42.3281 52.2856 42.3994ZM50.1865 43.0787C50.1858 43.0775 50.1849 43.0763 50.1841 43.075C50.3606 42.8064 50.5666 42.5547 50.7935 42.3281C50.9028 42.219 51.0205 42.1141 51.1382 42.0133C51.2643 41.9084 51.3988 41.8077 51.5375 41.7196C51.7224 41.8413 51.8989 41.9798 52.0671 42.1266C52.1427 42.1938 52.2142 42.2609 52.2856 42.3323C52.4201 42.4665 52.5462 42.605 52.6597 42.7561C52.7369 42.8525 52.8071 42.9524 52.8766 43.0526C52.8772 43.0517 52.8778 43.0509 52.8784 43.05C52.8809 43.0537 52.8834 43.0571 52.8858 43.0603C52.8914 43.0679 52.8965 43.0747 52.8994 43.0835C52.8969 43.0873 52.8944 43.0907 52.892 43.0939C52.8864 43.1015 52.8813 43.1083 52.8784 43.1171C52.6598 43.4402 52.4035 43.734 52.1135 43.9983C51.9369 44.1578 51.7436 44.3089 51.5418 44.4389C51.4116 44.3508 51.2813 44.2585 51.1594 44.1578C51.0333 44.0529 50.9114 43.9438 50.7937 43.8305C50.7685 43.8053 50.7443 43.7801 50.7202 43.7549C50.696 43.7298 50.6718 43.7046 50.6466 43.6794C50.6439 43.6768 50.6413 43.6737 50.6385 43.6704C50.6325 43.6635 50.6258 43.6558 50.6172 43.65C50.4575 43.4738 50.3146 43.285 50.1801 43.0877C50.1822 43.0845 50.1844 43.0815 50.1865 43.0787Z",
    fill: "url(#paint186_radial_578_447537)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5371 42.1935C51.5371 42.1935 51.0075 42.525 50.6419 43.0873C50.6419 43.0831 50.9025 42.504 51.5371 42.1935Z",
    fill: "url(#paint187_radial_578_447537)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4277 43.084C52.4277 43.084 52.1125 43.6379 51.5787 43.9694L51.5367 44.3722L51.5073 43.961C51.5073 43.961 51.108 43.7932 50.6415 43.084C50.6415 43.084 51.2299 43.8729 51.5451 43.9148C51.5451 43.919 51.9108 43.7764 52.4277 43.084Z",
    fill: "url(#paint188_radial_578_447537)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5332 43.9735C51.5332 43.9735 50.9784 43.6588 50.6464 43.1258L50.2429 43.0839L50.6548 43.0545C50.6548 43.0545 50.8229 42.6558 51.5332 42.1901C51.5332 42.1901 50.743 42.7775 50.701 43.0923C50.6968 43.0923 50.8397 43.4573 51.5332 43.9735Z",
    fill: "url(#paint189_radial_578_447537)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5544 42.1901C51.5544 42.1901 52.1092 42.5048 52.4412 43.0377L52.8447 43.0797L52.4328 43.109C52.4328 43.109 52.2647 43.5077 51.5544 43.9735C51.5544 43.9735 52.3446 43.386 52.3866 43.0713C52.3908 43.0713 52.2479 42.7062 51.5544 42.1901Z",
    fill: "url(#paint190_radial_578_447537)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6415 43.0792C50.6415 43.0792 50.9567 42.5252 51.4905 42.1937L51.5325 41.7909L51.5619 42.2021C51.5619 42.2021 51.9612 42.37 52.4277 43.0792C52.4277 43.0792 51.8393 42.2902 51.5241 42.2483C51.5241 42.2441 51.1584 42.3868 50.6415 43.0792Z",
    fill: "url(#paint191_radial_578_447537)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6712 46.3177C45.6363 46.3689 45.6364 46.4361 45.6714 46.4872C45.8319 46.7213 46.0098 46.9459 46.2013 47.1571C46.2126 47.1684 46.2239 47.1853 46.2408 47.1965C46.3029 47.2641 46.3706 47.3317 46.4383 47.3993C46.5963 47.5569 46.7544 47.7033 46.9293 47.8385C47.067 47.9522 47.2087 48.058 47.3578 48.1591C47.4091 48.1939 47.4764 48.1937 47.5268 48.1577C47.799 47.9629 48.1898 47.627 48.5213 47.2912C48.7964 47.0125 49.077 46.6496 49.2005 46.485C49.2399 46.4324 49.2406 46.3609 49.2028 46.3072C49.1336 46.2094 49.0227 46.0545 48.9496 45.9633C48.7916 45.7662 48.6223 45.5747 48.4473 45.3945C48.3514 45.2988 48.2555 45.2087 48.1539 45.1186C47.9543 44.9443 47.7459 44.7833 47.5286 44.6315C47.477 44.5954 47.4085 44.5951 47.3564 44.6306C47.2007 44.7368 47.0497 44.8477 46.9067 44.9666C46.7431 45.1017 46.5907 45.2425 46.444 45.3889C46.1529 45.6846 45.8953 45.9898 45.6712 46.3177Z",
    fill: "#043481"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0824 46.4005C46.2127 46.5978 46.3598 46.7866 46.5195 46.9628C46.5279 46.9712 46.5363 46.9838 46.5489 46.9922C46.5952 47.0426 46.6456 47.0929 46.6961 47.1433C46.8137 47.2608 46.9314 47.3699 47.0617 47.4706C47.1836 47.5713 47.3097 47.6636 47.4442 47.7517C47.6459 47.6175 47.8351 47.4706 48.0158 47.3111C48.3058 47.051 48.5622 46.7572 48.7807 46.4299C48.7891 46.4173 48.7976 46.4089 48.8018 46.3963C48.7261 46.2872 48.6504 46.1781 48.5664 46.0732C48.4487 45.9264 48.3226 45.7837 48.1923 45.6494C48.1209 45.5781 48.0494 45.5109 47.9738 45.4438C47.8056 45.2969 47.6291 45.1626 47.4442 45.0367C47.3055 45.1291 47.171 45.2256 47.0449 45.3305C46.923 45.4312 46.8095 45.5361 46.7003 45.6452C46.4649 45.8844 46.2589 46.132 46.0824 46.4005Z",
    fill: "url(#paint192_radial_578_447537)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0819 46.4006H47.4395V45.0494C47.1705 45.2257 46.9183 45.4313 46.6913 45.6579C46.4644 45.8845 46.2584 46.1321 46.0819 46.4006Z",
    fill: "url(#paint193_radial_578_447537)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4403 45.0496V46.405H48.7979C48.6213 46.1364 48.4154 45.8846 48.1884 45.658C47.9573 45.4314 47.7093 45.2258 47.4403 45.0496Z",
    fill: "url(#paint194_radial_578_447537)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4403 46.4006V47.756C47.9783 47.3993 48.4406 46.9378 48.7979 46.4006H47.4403Z",
    fill: "url(#paint195_radial_578_447537)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0819 46.4006C46.2584 46.6692 46.4644 46.921 46.6913 47.1476C46.9183 47.3742 47.1705 47.5798 47.4395 47.756V46.4006H46.0819Z",
    fill: "url(#paint196_radial_578_447537)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0821 46.4005C46.2586 46.669 46.4645 46.9208 46.6915 47.1474C46.9185 47.374 47.1706 47.5796 47.4396 47.7559C47.6414 47.6216 47.7128 47.5754 47.8936 47.416L47.0403 45.343C46.9185 45.4437 46.805 45.5486 46.6957 45.6577C46.4645 45.8843 46.2586 46.1319 46.0821 46.4005Z",
    fill: "url(#paint197_radial_578_447537)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5446 46.9961C46.5908 47.0465 46.6412 47.0968 46.6917 47.1472C46.9186 47.3738 47.1708 47.5794 47.4398 47.7557C47.6416 47.6214 47.8307 47.4745 48.0114 47.3151C48.3014 47.0549 48.5578 46.7611 48.7764 46.4338C48.209 46.6017 47.3768 46.8325 46.5446 46.9961Z",
    fill: "url(#paint198_radial_578_447537)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5186 46.9629C46.527 46.9713 46.5354 46.9839 46.548 46.9922C46.5943 47.0426 46.6447 47.093 46.6951 47.1433C46.8128 47.2608 46.9305 47.3699 47.0608 47.4706C47.3802 46.9041 47.7333 46.2243 47.7627 45.96C47.7585 45.9642 47.0524 46.5474 46.5186 46.9629Z",
    fill: "url(#paint199_radial_578_447537)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4393 46.4007L48.5615 46.0776C48.4438 45.9307 48.3177 45.788 48.1875 45.6537C48.116 45.5824 48.0446 45.5153 47.9689 45.4481L47.4393 46.4007Z",
    fill: "url(#paint200_radial_578_447537)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4397 47.2947C47.7928 47.0597 48.0996 46.7576 48.335 46.4009C48.0996 46.0484 47.797 45.7421 47.4397 45.5071C47.0867 45.7421 46.7798 46.0442 46.5445 46.4009C46.7798 46.7576 47.0825 47.0597 47.4397 47.2947Z",
    fill: "url(#paint201_radial_578_447537)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5615 46.1404C48.4438 45.9935 48.3177 45.8508 48.1874 45.7165C48.116 45.6452 48.0445 45.5781 47.9689 45.5109C47.8008 45.3641 47.6242 45.2298 47.4393 45.1039C47.3006 45.1962 47.1661 45.2927 47.04 45.3976C46.9181 45.4983 46.8047 45.6032 46.6954 45.7123C46.4768 45.9305 46.2793 46.1697 46.107 46.4257C46.0985 46.4131 46.0943 46.4047 46.0859 46.3921C46.2625 46.1236 46.4684 45.8718 46.6954 45.6452C46.8047 45.5361 46.9223 45.4312 47.04 45.3305C47.1661 45.2256 47.3006 45.1249 47.4393 45.0367C47.6242 45.1584 47.8008 45.2969 47.9689 45.4438C48.0445 45.5109 48.116 45.5781 48.1874 45.6494C48.3219 45.7837 48.448 45.9222 48.5615 46.0732C48.6456 46.1781 48.7212 46.2872 48.7969 46.3963C48.7885 46.4089 48.7843 46.4173 48.7759 46.4299C48.7044 46.3334 48.633 46.2369 48.5615 46.1404Z",
    fill: "url(#paint202_radial_578_447537)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5195 46.9C46.5279 46.9084 46.5363 46.921 46.5489 46.9294C46.5952 46.9797 46.6456 47.0301 46.6961 47.0804C46.8137 47.1979 46.9314 47.307 47.0617 47.4077C47.1836 47.5085 47.3097 47.6008 47.4442 47.6889C47.6459 47.5546 47.8351 47.4077 48.0158 47.2483C48.3058 46.9881 48.5622 46.6944 48.7807 46.3671C48.7891 46.3797 48.7976 46.388 48.8018 46.4006C48.7934 46.4132 48.7849 46.4216 48.7807 46.4342C48.5622 46.7573 48.3058 47.0511 48.0158 47.3154C47.8393 47.4749 47.6459 47.6259 47.4442 47.756C47.3139 47.6679 47.1836 47.5756 47.0617 47.4749C46.9356 47.37 46.8137 47.2609 46.6961 47.1476C46.6456 47.0972 46.5994 47.0469 46.5489 46.9965C46.5405 46.9881 46.5321 46.9755 46.5195 46.9671C46.3598 46.7909 46.2169 46.6021 46.0824 46.4048C46.0908 46.3922 46.0992 46.3839 46.1034 46.3713C46.2295 46.5559 46.3682 46.7321 46.5195 46.9Z",
    fill: "url(#paint203_radial_578_447537)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.188 45.7164C48.3182 45.8507 48.4443 45.9934 48.562 46.1402L48.7565 46.4029C48.5433 46.7158 48.2951 46.9976 48.0158 47.2482C47.8351 47.4077 47.6459 47.5545 47.4442 47.6888C47.3097 47.6007 47.1836 47.5084 47.0617 47.4077C46.9314 47.307 46.8137 47.1978 46.6961 47.0804C46.6456 47.03 46.5952 46.9796 46.5489 46.9293C46.5403 46.9235 46.5337 46.9159 46.5276 46.9089C46.5248 46.9056 46.5222 46.9026 46.5195 46.8999C46.3764 46.7412 46.2446 46.5749 46.124 46.4011C46.2924 46.1544 46.4843 45.9235 46.6959 45.7122C46.8052 45.6031 46.9186 45.4982 47.0405 45.3975C47.1666 45.2926 47.3011 45.1961 47.4398 45.1038C47.6248 45.2296 47.8013 45.3639 47.9694 45.5108C48.0451 45.5779 48.1165 45.6451 48.188 45.7164ZM46.0889 46.3957C46.0881 46.3945 46.0873 46.3933 46.0865 46.392C46.263 46.1235 46.4689 45.8717 46.6959 45.6451C46.8052 45.536 46.9228 45.4311 47.0405 45.3304C47.1666 45.2255 47.3011 45.1247 47.4398 45.0366C47.6248 45.1583 47.8013 45.2968 47.9694 45.4437C48.0451 45.5108 48.1165 45.5779 48.188 45.6493C48.3225 45.7836 48.4485 45.922 48.562 46.0731C48.6393 46.1695 48.7094 46.2694 48.779 46.3696C48.7796 46.3688 48.7801 46.3679 48.7807 46.367C48.7833 46.3707 48.7858 46.3741 48.7882 46.3774C48.7938 46.385 48.7988 46.3917 48.8018 46.4006C48.7992 46.4043 48.7967 46.4077 48.7943 46.4109C48.7887 46.4185 48.7837 46.4253 48.7807 46.4341C48.5622 46.7572 48.3058 47.051 48.0158 47.3153C47.8393 47.4748 47.6459 47.6259 47.4442 47.756C47.3139 47.6678 47.1836 47.5755 47.0617 47.4748C46.9356 47.3699 46.8137 47.2608 46.6961 47.1475C46.6708 47.1223 46.6467 47.0971 46.6225 47.072C46.5983 47.0468 46.5742 47.0216 46.5489 46.9964C46.5463 46.9938 46.5436 46.9907 46.5408 46.9875C46.5348 46.9805 46.5281 46.9728 46.5195 46.9671C46.3598 46.7908 46.2169 46.602 46.0824 46.4048C46.0846 46.4015 46.0868 46.3985 46.0889 46.3957Z",
    fill: "url(#paint204_radial_578_447537)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4395 45.5105C47.4395 45.5105 46.9099 45.842 46.5442 46.4043C46.5442 46.4001 46.8048 45.821 47.4395 45.5105Z",
    fill: "url(#paint205_radial_578_447537)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3301 46.401C48.3301 46.401 48.0149 46.9549 47.4811 47.2864L47.439 47.6893L47.4096 47.278C47.4096 47.278 47.0103 47.1102 46.5438 46.401C46.5438 46.401 47.1322 47.1899 47.4474 47.2319C47.4474 47.2361 47.8131 47.0934 48.3301 46.401Z",
    fill: "url(#paint206_radial_578_447537)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4355 47.2905C47.4355 47.2905 46.8807 46.9758 46.5487 46.4428L46.1452 46.4009L46.5571 46.3715C46.5571 46.3715 46.7252 45.9729 47.4355 45.5071C47.4355 45.5071 46.6454 46.0946 46.6034 46.4093C46.5991 46.4093 46.7421 46.7744 47.4355 47.2905Z",
    fill: "url(#paint207_radial_578_447537)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4567 45.5071C47.4567 45.5071 48.0115 45.8218 48.3436 46.3547L48.7471 46.3967L48.3352 46.4261C48.3352 46.4261 48.1671 46.8247 47.4567 47.2905C47.4567 47.2905 48.2469 46.703 48.2889 46.3883C48.2931 46.3883 48.1502 46.0232 47.4567 45.5071Z",
    fill: "url(#paint208_radial_578_447537)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5438 46.3962C46.5438 46.3962 46.859 45.8423 47.3928 45.5108L47.4348 45.1079L47.4643 45.5191C47.4643 45.5191 47.8635 45.687 48.3301 46.3962C48.3301 46.3962 47.7417 45.6073 47.4264 45.5653C47.4264 45.5611 47.0608 45.7038 46.5438 46.3962Z",
    fill: "url(#paint209_radial_578_447537)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5736 43.0007C41.5387 43.0519 41.5387 43.1191 41.5738 43.1702C41.7342 43.4043 41.9122 43.6289 42.1036 43.8401C42.1149 43.8514 42.1262 43.8682 42.1432 43.8795C42.2052 43.9471 42.2729 44.0147 42.3407 44.0822C42.4987 44.2399 42.6567 44.3863 42.8316 44.5215C42.9694 44.6352 43.1111 44.7409 43.2601 44.8421C43.3114 44.8769 43.3787 44.8767 43.4292 44.8407C43.7013 44.6459 44.0921 44.31 44.4236 43.9742C44.6988 43.6955 44.9793 43.3326 45.1028 43.168C45.1422 43.1154 45.143 43.0439 45.1051 42.9902C45.036 42.8924 44.925 42.7374 44.8519 42.6463C44.6939 42.4492 44.5246 42.2577 44.3497 42.0775C44.2538 41.9818 44.1578 41.8917 44.0562 41.8016C43.8566 41.6273 43.6482 41.4662 43.4309 41.3145C43.3793 41.2784 43.3108 41.2781 43.2588 41.3136C43.1031 41.4198 42.9521 41.5307 42.8091 41.6496C42.6454 41.7847 42.493 41.9255 42.3463 42.0719C42.0552 42.3675 41.7977 42.6728 41.5736 43.0007Z",
    fill: "#043481"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9848 43.0835C42.1151 43.2807 42.2622 43.4696 42.4219 43.6458C42.4303 43.6542 42.4387 43.6668 42.4513 43.6752C42.4975 43.7255 42.548 43.7759 42.5984 43.8263C42.7161 43.9438 42.8338 44.0529 42.9641 44.1536C43.0859 44.2543 43.212 44.3466 43.3465 44.4347C43.5483 44.3004 43.7374 44.1536 43.9181 43.9941C44.2081 43.7339 44.4645 43.4402 44.6831 43.1129C44.6915 43.1003 44.6999 43.0919 44.7041 43.0793C44.6284 42.9702 44.5528 42.8611 44.4687 42.7562C44.351 42.6093 44.225 42.4667 44.0947 42.3324C44.0232 42.261 43.9518 42.1939 43.8761 42.1268C43.708 41.9799 43.5315 41.8456 43.3465 41.7197C43.2078 41.812 43.0733 41.9086 42.9472 42.0135C42.8254 42.1142 42.7119 42.2191 42.6026 42.3282C42.3672 42.5674 42.1613 42.815 41.9848 43.0835Z",
    fill: "url(#paint210_radial_578_447537)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9842 43.0837H43.3418V41.7325C43.0728 41.9088 42.8206 42.1144 42.5937 42.341C42.3667 42.5676 42.1608 42.8152 41.9842 43.0837Z",
    fill: "url(#paint211_radial_578_447537)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3426 41.7325V43.0879H44.7002C44.5237 42.8194 44.3177 42.5676 44.0908 42.341C43.8596 42.1144 43.6116 41.9088 43.3426 41.7325Z",
    fill: "url(#paint212_radial_578_447537)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3426 43.0837V44.4391C43.8806 44.0825 44.3429 43.6209 44.7002 43.0837H43.3426Z",
    fill: "url(#paint213_radial_578_447537)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9842 43.0837C42.1608 43.3523 42.3667 43.6041 42.5937 43.8307C42.8206 44.0573 43.0728 44.2629 43.3418 44.4391V43.0837H41.9842Z",
    fill: "url(#paint214_radial_578_447537)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9844 43.0835C42.1609 43.352 42.3669 43.6038 42.5938 43.8304C42.8208 44.057 43.073 44.2626 43.342 44.4389C43.5437 44.3046 43.6152 44.2584 43.7959 44.099L42.9427 42.026C42.8208 42.1267 42.7073 42.2316 42.598 42.3407C42.3669 42.5673 42.1609 42.8149 41.9844 43.0835Z",
    fill: "url(#paint215_radial_578_447537)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4469 43.6791C42.4931 43.7295 42.5436 43.7798 42.594 43.8302C42.821 44.0568 43.0732 44.2624 43.3422 44.4386C43.5439 44.3044 43.733 44.1575 43.9138 43.998C44.2038 43.7379 44.4602 43.4441 44.6787 43.1168C44.1113 43.2847 43.2791 43.5155 42.4469 43.6791Z",
    fill: "url(#paint216_radial_578_447537)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4209 43.6459C42.4294 43.6542 42.4378 43.6668 42.4504 43.6752C42.4966 43.7256 42.547 43.7759 42.5975 43.8263C42.7152 43.9438 42.8328 44.0529 42.9631 44.1536C43.2826 43.5871 43.6356 42.9073 43.665 42.6429C43.6608 42.6471 42.9547 43.2304 42.4209 43.6459Z",
    fill: "url(#paint217_radial_578_447537)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3417 43.0837L44.4639 42.7605C44.3462 42.6137 44.2201 42.471 44.0898 42.3367C44.0183 42.2654 43.9469 42.1982 43.8712 42.1311L43.3417 43.0837Z",
    fill: "url(#paint218_radial_578_447537)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3421 43.9777C43.6951 43.7427 44.0019 43.4406 44.2373 43.0839C44.0019 42.7314 43.6993 42.4251 43.3421 42.1901C42.989 42.4251 42.6822 42.7272 42.4468 43.0839C42.6822 43.4406 42.9848 43.7427 43.3421 43.9777Z",
    fill: "url(#paint219_radial_578_447537)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4639 42.8233C44.3462 42.6765 44.2201 42.5338 44.0898 42.3995C44.0183 42.3282 43.9469 42.261 43.8712 42.1939C43.7031 42.047 43.5266 41.9128 43.3416 41.7869C43.2029 41.8792 43.0685 41.9757 42.9424 42.0806C42.8205 42.1813 42.707 42.2862 42.5977 42.3953C42.3792 42.6135 42.1816 42.8527 42.0093 43.1087C42.0009 43.0961 41.9967 43.0877 41.9883 43.0751C42.1648 42.8066 42.3708 42.5548 42.5977 42.3282C42.707 42.2191 42.8247 42.1142 42.9424 42.0135C43.0685 41.9086 43.2029 41.8078 43.3416 41.7197C43.5266 41.8414 43.7031 41.9799 43.8712 42.1268C43.9469 42.1939 44.0183 42.261 44.0898 42.3324C44.2243 42.4667 44.3504 42.6051 44.4639 42.7562C44.5479 42.8611 44.6236 42.9702 44.6992 43.0793C44.6908 43.0919 44.6866 43.1003 44.6782 43.1129C44.6068 43.0164 44.5353 42.9199 44.4639 42.8233Z",
    fill: "url(#paint220_radial_578_447537)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4219 43.583C42.4303 43.5914 42.4387 43.604 42.4513 43.6123C42.4975 43.6627 42.548 43.7131 42.5984 43.7634C42.7161 43.8809 42.8338 43.99 42.9641 44.0907C43.0859 44.1914 43.212 44.2838 43.3465 44.3719C43.5483 44.2376 43.7374 44.0907 43.9181 43.9313C44.2081 43.6711 44.4645 43.3774 44.6831 43.05C44.6915 43.0626 44.6999 43.071 44.7041 43.0836C44.6957 43.0962 44.6873 43.1046 44.6831 43.1172C44.4645 43.4403 44.2081 43.734 43.9181 43.9984C43.7416 44.1579 43.5483 44.3089 43.3465 44.439C43.2162 44.3509 43.0859 44.2586 42.9641 44.1579C42.838 44.053 42.7161 43.9439 42.5984 43.8306C42.548 43.7802 42.5017 43.7298 42.4513 43.6795C42.4429 43.6711 42.4345 43.6585 42.4219 43.6501C42.2622 43.4739 42.1193 43.285 41.9848 43.0878C41.9932 43.0752 42.0016 43.0668 42.0058 43.0542C42.1319 43.2389 42.2706 43.4151 42.4219 43.583Z",
    fill: "url(#paint221_radial_578_447537)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0903 42.3994C44.2206 42.5337 44.3467 42.6764 44.4644 42.8232L44.6588 43.0859C44.4456 43.3988 44.1975 43.6806 43.9181 43.9312C43.7374 44.0906 43.5483 44.2375 43.3465 44.3718C43.212 44.2837 43.0859 44.1914 42.9641 44.0906C42.8338 43.9899 42.7161 43.8808 42.5984 43.7633C42.548 43.713 42.4975 43.6626 42.4513 43.6123C42.4427 43.6065 42.436 43.5988 42.43 43.5919C42.4272 43.5886 42.4245 43.5856 42.4219 43.5829C42.2788 43.4241 42.1469 43.2579 42.0264 43.0841C42.1948 42.8374 42.3866 42.6064 42.5982 42.3952C42.7075 42.2861 42.821 42.1812 42.9429 42.0805C43.069 41.9756 43.2035 41.8791 43.3422 41.7867C43.5271 41.9126 43.7036 42.0469 43.8717 42.1938C43.9474 42.2609 44.0188 42.3281 44.0903 42.3994ZM41.9912 43.0787C41.9904 43.0775 41.9896 43.0763 41.9888 43.075C42.1653 42.8064 42.3713 42.5547 42.5982 42.3281C42.7075 42.219 42.8252 42.1141 42.9429 42.0133C43.069 41.9084 43.2035 41.8077 43.3422 41.7196C43.5271 41.8413 43.7036 41.9798 43.8717 42.1266C43.9474 42.1938 44.0188 42.2609 44.0903 42.3323C44.2248 42.4665 44.3509 42.605 44.4644 42.7561C44.5416 42.8525 44.6117 42.9524 44.6813 43.0526C44.6819 43.0517 44.6825 43.0509 44.6831 43.05C44.6856 43.0537 44.6881 43.0571 44.6905 43.0603C44.6961 43.0679 44.7012 43.0747 44.7041 43.0835C44.7016 43.0873 44.6991 43.0907 44.6967 43.0939C44.6911 43.1015 44.686 43.1083 44.6831 43.1171C44.4645 43.4402 44.2081 43.734 43.9181 43.9983C43.7416 44.1578 43.5483 44.3089 43.3465 44.4389C43.2162 44.3508 43.0859 44.2585 42.9641 44.1578C42.838 44.0529 42.7161 43.9438 42.5984 43.8305C42.5732 43.8053 42.549 43.7801 42.5248 43.7549C42.5007 43.7298 42.4765 43.7046 42.4513 43.6794C42.4486 43.6768 42.446 43.6737 42.4432 43.6704C42.4371 43.6635 42.4305 43.6558 42.4219 43.65C42.2622 43.4738 42.1193 43.285 41.9848 43.0877C41.9869 43.0845 41.9891 43.0815 41.9912 43.0787Z",
    fill: "url(#paint222_radial_578_447537)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3418 42.1935C43.3418 42.1935 42.8122 42.525 42.4466 43.0873C42.4466 43.0831 42.7071 42.504 43.3418 42.1935Z",
    fill: "url(#paint223_radial_578_447537)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2324 43.084C44.2324 43.084 43.9172 43.6379 43.3834 43.9694L43.3414 44.3722L43.312 43.961C43.312 43.961 42.9127 43.7932 42.4461 43.084C42.4461 43.084 43.0346 43.8729 43.3498 43.9148C43.3498 43.919 43.7155 43.7764 44.2324 43.084Z",
    fill: "url(#paint224_radial_578_447537)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3379 43.9735C43.3379 43.9735 42.7831 43.6588 42.4511 43.1258L42.0476 43.0839L42.4595 43.0545C42.4595 43.0545 42.6276 42.6558 43.3379 42.1901C43.3379 42.1901 42.5477 42.7775 42.5057 43.0923C42.5015 43.0923 42.6444 43.4573 43.3379 43.9735Z",
    fill: "url(#paint225_radial_578_447537)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 42.1901C43.3591 42.1901 43.9139 42.5048 44.2459 43.0377L44.6494 43.0797L44.2375 43.109C44.2375 43.109 44.0694 43.5077 43.3591 43.9735C43.3591 43.9735 44.1493 43.386 44.1913 43.0713C44.1955 43.0713 44.0526 42.7062 43.3591 42.1901Z",
    fill: "url(#paint226_radial_578_447537)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4461 43.0792C42.4461 43.0792 42.7614 42.5252 43.2952 42.1937L43.3372 41.7909L43.3666 42.2021C43.3666 42.2021 43.7659 42.37 44.2324 43.0792C44.2324 43.0792 43.644 42.2902 43.3288 42.2483C43.3288 42.2441 42.9631 42.3868 42.4461 43.0792Z",
    fill: "url(#paint227_radial_578_447537)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4652 39.2451C37.4303 39.2962 37.4303 39.3635 37.4654 39.4146C37.6258 39.6487 37.8038 39.8733 37.9953 40.0845C38.0065 40.0957 38.0178 40.1126 38.0348 40.1239C38.0968 40.1915 38.1645 40.259 38.2323 40.3266C38.3903 40.4843 38.5483 40.6307 38.7232 40.7659C38.861 40.8796 39.0027 40.9853 39.1517 41.0865C39.203 41.1213 39.2704 41.1211 39.3208 41.085C39.5929 40.8903 39.9837 40.5544 40.3152 40.2186C40.5904 39.9398 40.8709 39.577 40.9944 39.4123C41.0338 39.3598 41.0346 39.2883 40.9967 39.2346C40.9276 39.1367 40.8166 38.9818 40.7435 38.8907C40.5855 38.6936 40.4162 38.5021 40.2413 38.3219C40.1454 38.2262 40.0494 38.1361 39.9478 38.046C39.7482 37.8717 39.5398 37.7106 39.3225 37.5589C39.2709 37.5228 39.2024 37.5225 39.1504 37.5579C38.9947 37.6642 38.8437 37.775 38.7007 37.8939C38.537 38.0291 38.3846 38.1699 38.2379 38.3163C37.9468 38.6119 37.6893 38.9171 37.4652 39.2451Z",
    fill: "#093B8C"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8764 39.3279C38.0067 39.5251 38.1538 39.714 38.3135 39.8902C38.3219 39.8986 38.3303 39.9112 38.3429 39.9196C38.3891 39.9699 38.4396 40.0203 38.49 40.0706C38.6077 40.1881 38.7254 40.2972 38.8557 40.398C38.9775 40.4987 39.1036 40.591 39.2381 40.6791C39.4399 40.5448 39.629 40.3979 39.8097 40.2385C40.0997 39.9783 40.3561 39.6846 40.5747 39.3573C40.5831 39.3447 40.5915 39.3363 40.5957 39.3237C40.52 39.2146 40.4444 39.1055 40.3603 39.0006C40.2427 38.8537 40.1166 38.711 39.9863 38.5768C39.9148 38.5054 39.8434 38.4383 39.7677 38.3711C39.5996 38.2243 39.4231 38.09 39.2381 37.9641C39.0994 38.0564 38.9649 38.1529 38.8388 38.2579C38.717 38.3586 38.6035 38.4635 38.4942 38.5726C38.2588 38.8118 38.0529 39.0593 37.8764 39.3279Z",
    fill: "url(#paint228_radial_578_447537)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8758 39.3281H39.2334V37.9769C38.9644 38.1532 38.7122 38.3588 38.4853 38.5854C38.2583 38.812 38.0524 39.0596 37.8758 39.3281Z",
    fill: "url(#paint229_radial_578_447537)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2342 37.9769V39.3323H40.5918C40.4153 39.0638 40.2093 38.812 39.9824 38.5854C39.7512 38.3588 39.5032 38.1532 39.2342 37.9769Z",
    fill: "url(#paint230_radial_578_447537)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2342 39.3281V40.6835C39.7722 40.3268 40.2345 39.8652 40.5918 39.3281H39.2342Z",
    fill: "url(#paint231_radial_578_447537)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8758 39.3281C38.0524 39.5967 38.2583 39.8485 38.4853 40.0751C38.7122 40.3017 38.9644 40.5073 39.2334 40.6835V39.3281H37.8758Z",
    fill: "url(#paint232_radial_578_447537)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M37.876 39.3278C38.0525 39.5964 38.2585 39.8482 38.4854 40.0748C38.7124 40.3014 38.9646 40.507 39.2336 40.6832C39.4353 40.549 39.5068 40.5028 39.6875 40.3433L38.8343 38.2704C38.7124 38.3711 38.5989 38.476 38.4896 38.5851C38.2585 38.8117 38.0525 39.0593 37.876 39.3278Z",
    fill: "url(#paint233_radial_578_447537)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3385 39.9235C38.3848 39.9739 38.4352 40.0242 38.4856 40.0746C38.7126 40.3012 38.9648 40.5068 39.2338 40.683C39.4355 40.5488 39.6246 40.4019 39.8054 40.2424C40.0954 39.9823 40.3518 39.6885 40.5703 39.3612C40.0029 39.5291 39.1707 39.7599 38.3385 39.9235Z",
    fill: "url(#paint234_radial_578_447537)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3126 39.8902C38.321 39.8986 38.3294 39.9112 38.342 39.9196C38.3882 39.97 38.4386 40.0203 38.4891 40.0707C38.6068 40.1882 38.7244 40.2973 38.8547 40.398C39.1742 39.8315 39.5272 39.1517 39.5566 38.8873C39.5524 38.8915 38.8463 39.4748 38.3126 39.8902Z",
    fill: "url(#paint235_radial_578_447537)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2333 39.328L40.3555 39.0049C40.2378 38.8581 40.1117 38.7154 39.9814 38.5811C39.9099 38.5098 39.8385 38.4426 39.7628 38.3755L39.2333 39.328Z",
    fill: "url(#paint236_radial_578_447537)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2337 40.2221C39.5867 39.9871 39.8935 39.6849 40.1289 39.3283C39.8935 38.9758 39.5909 38.6694 39.2337 38.4344C38.8806 38.6694 38.5738 38.9716 38.3384 39.3283C38.5738 39.6849 38.8764 39.9871 39.2337 40.2221Z",
    fill: "url(#paint237_radial_578_447537)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3555 39.0677C40.2378 38.9209 40.1117 38.7782 39.9814 38.6439C39.9099 38.5726 39.8385 38.5054 39.7628 38.4383C39.5947 38.2914 39.4182 38.1571 39.2333 38.0313C39.0946 38.1236 38.9601 38.2201 38.834 38.325C38.7121 38.4257 38.5986 38.5306 38.4893 38.6397C38.2708 38.8579 38.0732 39.0971 37.9009 39.3531C37.8925 39.3405 37.8883 39.3321 37.8799 39.3195C38.0564 39.0509 38.2624 38.7992 38.4893 38.5726C38.5986 38.4635 38.7163 38.3586 38.834 38.2579C38.9601 38.1529 39.0946 38.0522 39.2333 37.9641C39.4182 38.0858 39.5947 38.2243 39.7628 38.3711C39.8385 38.4383 39.9099 38.5054 39.9814 38.5768C40.1159 38.711 40.242 38.8495 40.3555 39.0006C40.4395 39.1055 40.5152 39.2146 40.5908 39.3237C40.5824 39.3363 40.5782 39.3447 40.5698 39.3573C40.4984 39.2608 40.4269 39.1642 40.3555 39.0677Z",
    fill: "url(#paint238_radial_578_447537)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3135 39.8274C38.3219 39.8358 38.3303 39.8483 38.3429 39.8567C38.3891 39.9071 38.4396 39.9574 38.49 40.0078C38.6077 40.1253 38.7254 40.2344 38.8557 40.3351C38.9775 40.4358 39.1036 40.5281 39.2381 40.6163C39.4399 40.482 39.629 40.3351 39.8097 40.1757C40.0997 39.9155 40.3561 39.6217 40.5747 39.2944C40.5831 39.307 40.5915 39.3154 40.5957 39.328C40.5873 39.3406 40.5789 39.349 40.5747 39.3616C40.3561 39.6847 40.0997 39.9784 39.8097 40.2428C39.6332 40.4023 39.4399 40.5533 39.2381 40.6834C39.1078 40.5953 38.9775 40.503 38.8557 40.4022C38.7296 40.2973 38.6077 40.1882 38.49 40.0749C38.4396 40.0246 38.3933 39.9742 38.3429 39.9239C38.3345 39.9155 38.3261 39.9029 38.3135 39.8945C38.1538 39.7183 38.0109 39.5294 37.8764 39.3322C37.8848 39.3196 37.8932 39.3112 37.8974 39.2986C38.0235 39.4833 38.1622 39.6595 38.3135 39.8274Z",
    fill: "url(#paint239_radial_578_447537)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9819 38.6438C40.1122 38.7781 40.2383 38.9207 40.356 39.0676L40.5504 39.3303C40.3372 39.6432 40.0891 39.925 39.8097 40.1756C39.629 40.335 39.4399 40.4819 39.2381 40.6162C39.1036 40.5281 38.9775 40.4357 38.8557 40.335C38.7254 40.2343 38.6077 40.1252 38.49 40.0077C38.4396 39.9574 38.3891 39.907 38.3429 39.8567C38.3343 39.8509 38.3276 39.8432 38.3216 39.8362C38.3188 39.833 38.3161 39.8299 38.3135 39.8273C38.1704 39.6685 38.0385 39.5023 37.918 39.3285C38.0864 39.0817 38.2783 38.8508 38.4898 38.6396C38.5991 38.5305 38.7126 38.4256 38.8345 38.3249C38.9606 38.22 39.0951 38.1234 39.2338 38.0311C39.4187 38.157 39.5952 38.2913 39.7633 38.4382C39.839 38.5053 39.9104 38.5724 39.9819 38.6438ZM37.8828 39.3231C37.882 39.3219 37.8812 39.3206 37.8804 39.3194C38.0569 39.0508 38.2629 38.799 38.4898 38.5724C38.5991 38.4633 38.7168 38.3584 38.8345 38.2577C38.9606 38.1528 39.0951 38.0521 39.2338 37.964C39.4187 38.0857 39.5952 38.2242 39.7633 38.371C39.839 38.4382 39.9104 38.5053 39.9819 38.5766C40.1164 38.7109 40.2425 38.8494 40.356 39.0005C40.4332 39.0969 40.5033 39.1968 40.5729 39.297C40.5735 39.2961 40.5741 39.2952 40.5747 39.2944C40.5772 39.2981 40.5797 39.3015 40.5821 39.3047C40.5877 39.3123 40.5928 39.3191 40.5957 39.3279C40.5932 39.3317 40.5907 39.3351 40.5883 39.3383C40.5827 39.3459 40.5776 39.3527 40.5747 39.3615C40.3561 39.6846 40.0997 39.9783 39.8097 40.2427C39.6332 40.4022 39.4399 40.5532 39.2381 40.6833C39.1078 40.5952 38.9775 40.5029 38.8557 40.4022C38.7296 40.2973 38.6077 40.1882 38.49 40.0749C38.4648 40.0497 38.4406 40.0245 38.4164 39.9993C38.3923 39.9741 38.3681 39.949 38.3429 39.9238C38.3402 39.9211 38.3376 39.9181 38.3348 39.9148C38.3287 39.9079 38.3221 39.9002 38.3135 39.8944C38.1538 39.7182 38.0109 39.5293 37.8764 39.3321C37.8785 39.3289 37.8807 39.3259 37.8828 39.3231Z",
    fill: "url(#paint240_radial_578_447537)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2334 38.4379C39.2334 38.4379 38.7038 38.7694 38.3382 39.3317C38.3382 39.3275 38.5987 38.7484 39.2334 38.4379Z",
    fill: "url(#paint241_radial_578_447537)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M40.124 39.3284C40.124 39.3284 39.8088 39.8823 39.275 40.2138L39.233 40.6166L39.2036 40.2054C39.2036 40.2054 38.8043 40.0375 38.3377 39.3284C38.3377 39.3284 38.9262 40.1173 39.2414 40.1592C39.2414 40.1634 39.6071 40.0208 40.124 39.3284Z",
    fill: "url(#paint242_radial_578_447537)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2295 40.2179C39.2295 40.2179 38.6747 39.9031 38.3427 39.3702L37.9392 39.3283L38.3511 39.2989C38.3511 39.2989 38.5192 38.9002 39.2295 38.4344C39.2295 38.4344 38.4393 39.0219 38.3973 39.3366C38.3931 39.3366 38.536 39.7017 39.2295 40.2179Z",
    fill: "url(#paint243_radial_578_447537)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2507 38.4344C39.2507 38.4344 39.8055 38.7492 40.1375 39.2821L40.541 39.3241L40.1291 39.3534C40.1291 39.3534 39.961 39.7521 39.2507 40.2179C39.2507 40.2179 40.0409 39.6304 40.0829 39.3157C40.0871 39.3157 39.9442 38.9506 39.2507 38.4344Z",
    fill: "url(#paint244_radial_578_447537)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3377 39.3235C38.3377 39.3235 38.653 38.7696 39.1868 38.4381L39.2288 38.0353L39.2582 38.4465C39.2582 38.4465 39.6575 38.6144 40.124 39.3235C40.124 39.3235 39.5356 38.5346 39.2204 38.4927C39.2204 38.4885 38.8547 38.6311 38.3377 39.3235Z",
    fill: "url(#paint245_radial_578_447537)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1572 15.1511C44.4809 15.1636 44.7548 15.1885 44.9913 15.2009C45.2153 15.2134 45.4021 15.2134 45.539 15.2134C45.7008 15.2134 46.0369 15.2009 46.5349 15.176C46.7216 15.1635 46.871 15.1636 46.9581 15.1636V15.5619C46.6843 15.5743 46.4975 15.6117 46.4104 15.6491C46.3232 15.6864 46.2859 15.7735 46.2859 15.898C46.2859 15.9478 46.2984 16.0225 46.3108 16.0972C46.3232 16.1719 46.3606 16.259 46.3979 16.3586L47.9664 20.8027L49.4478 16.371C49.4976 16.259 49.5225 16.1719 49.5349 16.1221C49.5474 16.0723 49.5474 15.9976 49.5474 15.9353C49.5474 15.7984 49.4976 15.6988 49.3856 15.6366C49.2735 15.5744 49.0868 15.5494 48.8254 15.5494V15.1511C49.0743 15.1636 49.2611 15.176 49.4229 15.1884C49.5847 15.2009 49.7092 15.2009 49.8213 15.2009C49.9084 15.2009 50.0204 15.2009 50.1574 15.1884C50.2943 15.176 50.4935 15.176 50.7424 15.1511V15.5494C50.5059 15.5619 50.3441 15.6117 50.2569 15.6739C50.1698 15.7362 50.0951 15.8357 50.0578 15.9851L48.4519 20.6035C48.3523 20.8774 48.2528 21.1637 48.1407 21.4624C48.0287 21.7612 47.9166 22.0725 47.7922 22.3837L47.2942 22.3338L44.9788 16.1968L44.9664 16.1595C44.817 15.7487 44.5556 15.5494 44.1821 15.5494L44.1572 15.1511Z",
    fill: "url(#paint246_radial_578_447537)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8536 20.5036L46.3847 16.3458C46.3473 16.2462 46.3225 16.1466 46.2976 16.0844C46.2727 16.0222 46.2727 15.9475 46.2727 15.8852C46.2727 15.8105 46.2851 15.7483 46.3225 15.6985C46.2478 15.7109 46.198 15.7234 46.1606 15.7483C46.0735 15.7981 46.0361 15.8728 46.0361 15.9972C46.0361 16.047 46.0486 16.1217 46.061 16.1964C46.0735 16.2711 46.1108 16.3583 46.1482 16.4579L47.7167 20.9019L47.8536 20.5036Z",
    fill: "url(#paint247_radial_578_447537)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7421 15.3129C44.9661 15.3254 45.1528 15.3254 45.2898 15.3254C45.4516 15.3254 45.7877 15.313 46.2857 15.2881C46.4724 15.2756 46.6218 15.2756 46.7089 15.2756V15.5744C46.7836 15.5619 46.8583 15.5619 46.9454 15.5619V15.1636C46.8458 15.1636 46.7089 15.176 46.5222 15.176C46.0242 15.2009 45.6881 15.2134 45.5263 15.2134C45.4018 15.2134 45.2151 15.2009 44.9786 15.2009C44.7545 15.1885 44.4682 15.176 44.1445 15.1511V15.2881C44.3811 15.3005 44.5802 15.3005 44.7421 15.3129Z",
    fill: "url(#paint248_radial_578_447537)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1445 15.1883C50.0075 15.2008 49.8955 15.2008 49.8084 15.2008C49.6963 15.2008 49.5719 15.2008 49.41 15.1883C49.2482 15.1759 49.0615 15.1759 48.8125 15.151V15.288C48.9494 15.3004 49.0739 15.3004 49.1735 15.3004C49.3353 15.3128 49.4598 15.3128 49.5718 15.3128C49.659 15.3128 49.771 15.3128 49.908 15.3004C50.0449 15.2879 50.2441 15.2879 50.493 15.263V15.5618C50.5677 15.5493 50.6424 15.5369 50.7296 15.5245V15.1261C50.4806 15.1634 50.2814 15.1759 50.1445 15.1883Z",
    fill: "url(#paint249_radial_578_447537)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9951 15.7856C49.9079 15.8354 49.8332 15.9475 49.7959 16.0969L48.1901 20.7152C48.0905 20.989 47.9909 21.2754 47.8788 21.5741C47.7917 21.8231 47.6797 22.0845 47.5801 22.3584L47.7668 22.3708C47.8913 22.0596 48.0033 21.7484 48.1154 21.4497C48.2274 21.1509 48.327 20.8645 48.4266 20.5907L50.0324 15.9724C50.0698 15.8603 50.1196 15.7732 50.1818 15.7109C50.1071 15.7234 50.0449 15.7483 49.9951 15.7856Z",
    fill: "url(#paint250_radial_578_447537)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1438 56.8418) scale(12.9425 12.9384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0669241,
    stopColor: "#327DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2368 53.5088) scale(8.83747 8.83466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1589,
    stopColor: "#B4FDFF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3069,
    stopColor: "#A9F7FD",
    stopOpacity: 0.6931
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4507,
    stopColor: "#96EDFB",
    stopOpacity: 0.5493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5918,
    stopColor: "#7CDEF8",
    stopOpacity: 0.4082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7311,
    stopColor: "#59CCF5",
    stopOpacity: 0.2689
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#30B5F0",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4194 43.0867) scale(18.3174 18.3117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5962 56.8421) rotate(180) scale(12.9425 12.9384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0669241,
    stopColor: "#327DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5033 53.5091) rotate(180) scale(8.83747 8.83466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1589,
    stopColor: "#B4FDFF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3069,
    stopColor: "#A9F7FD",
    stopOpacity: 0.6931
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4507,
    stopColor: "#96EDFB",
    stopOpacity: 0.5493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5918,
    stopColor: "#7CDEF8",
    stopOpacity: 0.4082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7311,
    stopColor: "#59CCF5",
    stopOpacity: 0.2689
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#30B5F0",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3206 43.0869) rotate(180) scale(18.3174 18.3117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4591 47.7984) scale(13.745 13.7407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0669241,
    stopColor: "#327DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6392 49.5574) scale(9.84763 9.8445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1589,
    stopColor: "#B4FDFF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3069,
    stopColor: "#A9F7FD",
    stopOpacity: 0.6931
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4507,
    stopColor: "#96EDFB",
    stopOpacity: 0.5493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5918,
    stopColor: "#7CDEF8",
    stopOpacity: 0.4082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7311,
    stopColor: "#59CCF5",
    stopOpacity: 0.2689
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#30B5F0",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.077 38.2388) scale(17.6993 17.6938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.2777 47.7984) rotate(180) scale(13.745 13.7407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0669241,
    stopColor: "#327DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0985 49.5574) rotate(180) scale(9.8477 9.84456)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1589,
    stopColor: "#B4FDFF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3069,
    stopColor: "#A9F7FD",
    stopOpacity: 0.6931
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4507,
    stopColor: "#96EDFB",
    stopOpacity: 0.5493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5918,
    stopColor: "#7CDEF8",
    stopOpacity: 0.4082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7311,
    stopColor: "#59CCF5",
    stopOpacity: 0.2689
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#30B5F0",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6598 38.2388) rotate(180) scale(17.6993 17.6938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3753 18.3917) scale(9.77248 9.76938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8863,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9353,
    stopColor: "#FDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9529,
    stopColor: "#F6FDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9655,
    stopColor: "#EBFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9757,
    stopColor: "#DAF8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9844,
    stopColor: "#C4F4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9921,
    stopColor: "#A8F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#89EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83E9F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3747 14.6074) scale(18.2676 18.2619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6467 17.9366) scale(10.3348 10.3315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3628,
    stopColor: "#0062FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4333,
    stopColor: "#005DF0",
    stopOpacity: 0.1106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6932,
    stopColor: "#004BBE",
    stopOpacity: 0.5186
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8903,
    stopColor: "#00409F",
    stopOpacity: 0.8278
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003C93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2915 -9.76516) scale(32.0656 40.722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7841 13.5939) scale(11.3168 11.3133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2336 13.5939) rotate(180) scale(11.3168 11.3133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3826 0.290925) scale(22.0892 22.0822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1974 -10.7477) scale(30.3568 34.4211)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5854 33.3851) rotate(180) scale(15.8212 12.8276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1963 6.70418) scale(26.524 26.5155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90A4DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2562 30.0974) scale(11.0994 11.0959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3745 8.346) scale(23.1347 23.1274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5079,
    stopColor: "#00BFD3",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5522,
    stopColor: "#09C1D5",
    stopOpacity: 0.6361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6242,
    stopColor: "#21C7D9",
    stopOpacity: 0.6945
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#48D1E0",
    stopOpacity: 0.7681
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#7FDEEB",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9373,
    stopColor: "#C3EFF8",
    stopOpacity: 0.9491
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6688 9.96653) scale(9.5538 9.55078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0442 9.96653) rotate(180) scale(9.55372 9.55078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5028 11.2942) scale(7.91915 7.91663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.235 11.2943) rotate(180) scale(7.91915 7.91664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8266 18.5091) scale(9.05294 9.05007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.86 18.5091) rotate(180) scale(9.05295 9.05007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0716 28.5033) rotate(90) scale(9.0501 9.05294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7874 9.84405) scale(7.48474 7.48238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.9583 9.87105) rotate(180) scale(7.48475 7.48238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4676 7.09336) scale(3.57734 3.57622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6FFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8FFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8765 4.75243) scale(9.5959 9.59296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0446 4.64472) scale(6.56369 6.56159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2267 10.5124) scale(3.94836 3.94709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8991 8.60914) scale(3.26634 3.26531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5323 6.09696) scale(6.9721 6.96991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7418 7.54096) scale(3.35012 3.34906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFCF9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5703 8.81902) scale(3.18334 3.18234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFCF9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.3136 8.41963) scale(7.88783 7.88535)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFCF9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5582 10.4432) scale(6.2005 6.19852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFCF9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.0044 25.7049) scale(28.0299 28.021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1879,
    stopColor: "#90E5FF",
    stopOpacity: 0.8121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5536,
    stopColor: "#B9EFFF",
    stopOpacity: 0.4464
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.2271 27.0194) scale(17.0677 17.0623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.261 19.437) scale(0.304533 0.304497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.2463 21.6662) scale(10.0856 10.0824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.2832 16.9964) scale(11.5365 11.5328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.47 33.1917) scale(14.8507 14.846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.6196 26.2637) scale(8.4839 8.48122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.0548 24.9879) scale(6.55662 6.55458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.8389 37.4402) scale(11.7477 11.744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.0559 30.0912) scale(7.64595 7.64361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.7094 30.7165) scale(4.52688 4.52546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6647 36.1262) scale(14.0323 14.0277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.9469 28.1204) scale(10.7686 10.7652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.2587 27.1572) scale(6.2861 6.28411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4166 26.3421) scale(15.9464 15.9414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.1155 20.1583) scale(14.0951 14.0906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.6814 18.0637) scale(12.2262 12.2224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.2192 38.7503) scale(10.6128 10.6096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.3124 38.7566) scale(10.4716 10.4684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0984 33.7536) scale(3.40163 3.40053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.6061 12.445) scale(19.477 19.4708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.0443 10.5151) scale(11.7001 11.6965)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_578_447537",
    x1: 59.7312,
    y1: 26.4161,
    x2: 53.7156,
    y2: 16.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ECFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89ECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6567 12.2484) scale(13.2484 13.2442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#00E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2041 15.2308) scale(22.0194 22.0124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.567 19.8733) scale(12.9403 12.9362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.7028 17.6656) scale(20.7217 20.7151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2044 12.9751) scale(11.3494 11.3458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEBFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.4509 18.19) scale(20.4849 20.4784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055F2",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.0161 24.0055) scale(6.26076 6.25879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5823 19.8675) scale(9.04984 9.04698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.429 25.7325) scale(9.11921 9.11632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BA5F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.6499 29.582) scale(11.9671 11.9633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BA5F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4727 24.041) scale(4.56416 4.56272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0276A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEFFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9947 21.5711) scale(10.6699 10.6665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEFFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.1815 29.5614) scale(9.40569 9.40273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEFFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.3954 30.7285) scale(19.1239 19.1179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEBFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9479 26.3253) scale(8.92744 8.92464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEBFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9711 17.6959) scale(8.83456 8.83179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4135 18.8507) scale(3.77553 3.77469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.5511 18.2918) scale(3.75765 3.75652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9848 19.9717) scale(15.2208 15.2159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEBFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7289 25.7046) rotate(180) scale(28.0299 28.021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1879,
    stopColor: "#90E5FF",
    stopOpacity: 0.8121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5536,
    stopColor: "#B9EFFF",
    stopOpacity: 0.4464
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5067 27.0192) rotate(180) scale(17.0677 17.0623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4735 19.4368) rotate(180) scale(0.304546 0.304497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.48737 21.6659) rotate(180) scale(10.0856 10.0824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4501 16.9962) rotate(180) scale(11.5365 11.5328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2639 33.1914) rotate(180) scale(14.8507 14.846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1143 26.2634) rotate(180) scale(8.48391 8.48121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6791 24.9876) rotate(180) scale(6.55661 6.55458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.8949 37.44) rotate(180) scale(11.7477 11.744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.678 30.0908) rotate(180) scale(7.64595 7.64364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0241 30.7163) rotate(180) scale(4.52689 4.52546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0697 36.126) rotate(180) scale(14.0323 14.0277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7878 28.1201) rotate(180) scale(10.7686 10.7652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4754 27.1568) rotate(180) scale(6.2861 6.28411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3167 26.3417) rotate(180) scale(15.9464 15.9414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6177 20.1579) rotate(180) scale(14.0951 14.0906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0515 18.0632) rotate(180) scale(12.2262 12.2224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5142 38.7501) rotate(180) scale(10.6129 10.6096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4208 38.7564) rotate(180) scale(10.4716 10.4684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.6348 33.7533) rotate(180) scale(3.40163 3.40056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.12724 12.4447) rotate(180) scale(19.477 19.4708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6889 10.5148) rotate(180) scale(11.7001 11.6965)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_578_447537",
    x1: 35.0031,
    y1: 26.4165,
    x2: 41.0187,
    y2: 16.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ECFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89ECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0767 12.2482) rotate(180) scale(13.2484 13.2442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#00E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5295 15.2307) rotate(180) scale(22.0194 22.0124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1656 19.8732) rotate(180) scale(12.9403 12.9362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0302 17.6655) rotate(180) scale(20.7217 20.7151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.529 12.9749) rotate(180) scale(11.3494 11.3458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEBFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2829 18.19) rotate(180) scale(20.4849 20.4784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055F2",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7178 24.0055) rotate(180) scale(6.26079 6.25879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1518 19.8675) rotate(180) scale(9.04984 9.04698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.305 25.7325) rotate(180) scale(9.11921 9.11633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BA5F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0835 29.5819) rotate(180) scale(11.9671 11.9633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BA5F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2613 24.041) rotate(180) scale(4.56416 4.56273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0276A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEFFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7393 21.571) rotate(180) scale(10.6699 10.6665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEFFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5529 29.5613) rotate(180) scale(9.40569 9.40273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEFFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.3387 30.7283) rotate(180) scale(19.1239 19.1178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEBFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7859 26.325) rotate(180) scale(8.92744 8.92464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEBFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7623 17.6956) rotate(180) scale(8.83456 8.83178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3202 18.8504) rotate(180) scale(3.77554 3.77469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1825 18.2915) rotate(180) scale(3.75766 3.75652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7486 19.9715) rotate(180) scale(15.2208 15.2159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEBFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.8588 29.9353) scale(9.94945 9.9463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.3876 36.1119) scale(4.37695 4.37557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2804 33.786) scale(3.84961 3.84839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8128 36.5454) scale(3.46809 3.46704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.8808 29.9352) rotate(180) scale(9.94946 9.9463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.352 36.1119) rotate(180) scale(4.37696 4.37557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4592 33.786) rotate(180) scale(3.8496 3.84839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9268 36.5454) rotate(180) scale(3.4681 3.46704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2628 28.0467) scale(30.7842 30.7744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3028 33.2375) scale(4.59629 4.59486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.5087 33.2375) rotate(180) scale(4.59634 4.59486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4792 32.5736) scale(22.6273 22.6205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0594 41.0768) scale(11.9943 11.9905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0845 39.4372) scale(12.6356 12.6316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6019 28.831) scale(13.0902 13.0858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4035 44.9144) rotate(0.335683) scale(12.7702 12.9872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0089EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4851,
    stopColor: "#0088AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009FEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6915 41.1734) scale(7.59243 7.58999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0869 49.1549) scale(13.5532 13.5488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00349B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6317 41.8019) scale(7.30564 7.3033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00349B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1329 40.9634) scale(21.0213 21.0147)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6743 43.9642) scale(17.5261 17.5206)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.9812 37.8523) scale(16.4555 16.4502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.788 37.8523) rotate(180) scale(16.4555 16.4502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3547 49.8395) scale(19.2227 19.2166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF9FE",
    stopOpacity: 0.9705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0775754,
    stopColor: "#AAF7FE",
    stopOpacity: 0.8114
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1495,
    stopColor: "#9FF1FC",
    stopOpacity: 0.6639
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2192,
    stopColor: "#8CE7FA",
    stopOpacity: 0.521
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2875,
    stopColor: "#72D9F7",
    stopOpacity: 0.3808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3549,
    stopColor: "#50C6F4",
    stopOpacity: 0.2427
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4205,
    stopColor: "#27B0EF",
    stopOpacity: 0.108
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4732,
    stopColor: "#009BEB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5433,
    stopColor: "#30B5F0",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#59CCF5",
    stopOpacity: 0.2689
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6883,
    stopColor: "#7CDEF8",
    stopOpacity: 0.4082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7626,
    stopColor: "#96EDFB",
    stopOpacity: 0.5493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8383,
    stopColor: "#A9F7FD",
    stopOpacity: 0.6931
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9163,
    stopColor: "#B4FDFF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8FFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2728 41.8214) scale(13.5455 13.5411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.455 50.0013) scale(9.37985 9.37686)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4155 41.2611) scale(4.39398 4.3926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3274 41.2611) rotate(180) scale(4.39398 4.3926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4577 9.12677) scale(7.70861 7.70616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0FFFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6394 37.6971) rotate(180) scale(4.0919 4.08535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#BCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0847 39.9874) rotate(180) scale(2.09715 2.09379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3145 37.8363) rotate(180) scale(2.04596 2.04268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.9439 38.7596) rotate(180) scale(2.75911 2.75469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.029 40.4022) rotate(180) scale(1.66217 1.65951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.111 38.5889) rotate(180) scale(1.90701 1.90396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.1444 38.6921) rotate(180) scale(2.85152 2.84695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4849 41.502) rotate(180) scale(2.91862 2.91395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8979 37.8166) rotate(180) scale(1.75539 1.75258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6134 38.8255) rotate(180) scale(3.96637 3.96002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6197 37.8337) rotate(180) scale(2.57997 2.57584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6197 40.7287) rotate(180) scale(2.28667 2.283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6197 40.7286) rotate(180) scale(2.28667 2.28301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9824 38.7331) rotate(180) scale(1.81589 1.81298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6676 40.0648) rotate(180) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8924 39.3615) rotate(-90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.388 39.2901) rotate(90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.596 38.5864) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5427 41.4527) rotate(180) scale(4.0919 4.08535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#BCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.988 43.743) rotate(180) scale(2.09715 2.09379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2179 41.5919) rotate(180) scale(2.04596 2.04268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8472 42.5152) rotate(180) scale(2.75911 2.75469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9323 44.1578) rotate(180) scale(1.66217 1.65951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0143 42.3446) rotate(180) scale(1.90701 1.90396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0477 42.4478) rotate(180) scale(2.85152 2.84695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3882 45.2576) rotate(180) scale(2.91862 2.91395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8012 41.5723) rotate(180) scale(1.75539 1.75258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5167 42.5812) rotate(180) scale(3.96637 3.96002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.523 41.5893) rotate(180) scale(2.57997 2.57584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.523 44.4843) rotate(180) scale(2.28667 2.283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.523 44.4842) rotate(180) scale(2.28667 2.28301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8857 42.4888) rotate(180) scale(1.81589 1.81298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5709 43.8205) rotate(180) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7957 43.1172) rotate(-90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2913 43.0457) rotate(90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4993 42.342) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4451 44.7697) rotate(180) scale(4.0919 4.08535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#BCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8903 47.0599) rotate(180) scale(2.09715 2.09379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1202 44.9089) rotate(180) scale(2.04596 2.04268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7495 45.8321) rotate(180) scale(2.75911 2.75469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8347 47.4747) rotate(180) scale(1.66217 1.65951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9166 45.6616) rotate(180) scale(1.90701 1.90396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.95 45.7648) rotate(180) scale(2.85152 2.84695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2906 48.5746) rotate(180) scale(2.91862 2.91395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7035 44.8893) rotate(180) scale(1.75539 1.75258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4191 45.8982) rotate(180) scale(3.96637 3.96002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4254 44.9063) rotate(180) scale(2.57997 2.57584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4254 47.8013) rotate(180) scale(2.28667 2.283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4254 47.8012) rotate(180) scale(2.28667 2.28301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.788 45.8058) rotate(180) scale(1.81589 1.81298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4732 47.1375) rotate(180) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6981 46.4342) rotate(-90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1936 46.3627) rotate(90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4017 45.659) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3474 41.4527) rotate(180) scale(4.0919 4.08535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#BCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.7927 43.743) rotate(180) scale(2.09715 2.09379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.0225 41.5919) rotate(180) scale(2.04596 2.04268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6519 42.5152) rotate(180) scale(2.75911 2.75469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.737 44.1578) rotate(180) scale(1.66217 1.65951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.819 42.3446) rotate(180) scale(1.90701 1.90396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.8524 42.4478) rotate(180) scale(2.85152 2.84695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1929 45.2576) rotate(180) scale(2.91862 2.91395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6059 41.5723) rotate(180) scale(1.75539 1.75258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3214 42.5812) rotate(180) scale(3.96637 3.96002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3277 41.5893) rotate(180) scale(2.57997 2.57584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3277 44.4843) rotate(180) scale(2.28667 2.283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3277 44.4842) rotate(180) scale(2.28667 2.28301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6904 42.4888) rotate(180) scale(1.81589 1.81298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3756 43.8205) rotate(180) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6004 43.1172) rotate(-90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.096 43.0457) rotate(90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.304 42.342) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.239 37.6971) rotate(180) scale(4.0919 4.08535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#BCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6843 39.9874) rotate(180) scale(2.09715 2.09379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9142 37.8363) rotate(180) scale(2.04596 2.04268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5435 38.7596) rotate(180) scale(2.75911 2.75469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6286 40.4022) rotate(180) scale(1.66217 1.65951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7106 38.5889) rotate(180) scale(1.90701 1.90396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.744 38.6921) rotate(180) scale(2.85152 2.84695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0845 41.502) rotate(180) scale(2.91862 2.91395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4975 37.8166) rotate(180) scale(1.75539 1.75258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.213 38.8255) rotate(180) scale(3.96637 3.96002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2193 37.8337) rotate(180) scale(2.57997 2.57584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2193 40.7287) rotate(180) scale(2.28667 2.283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2193 40.7286) rotate(180) scale(2.28667 2.28301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.582 38.7331) rotate(180) scale(1.81589 1.81298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2672 40.0648) rotate(180) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.492 39.3615) rotate(-90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9876 39.2901) rotate(90) scale(1.57682 1.57935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1956 38.5864) scale(1.57935 1.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9807 24.7736) scale(11.1155 11.1155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CBFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2FCFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3613 17.9368) scale(12.3457 12.3456)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1402,
    stopColor: "#003346",
    stopOpacity: 0.8598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    stopColor: "#003E53",
    stopOpacity: 0.7141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    stopColor: "#005067",
    stopOpacity: 0.5659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    stopColor: "#006B85",
    stopOpacity: 0.4159
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7355,
    stopColor: "#008CAA",
    stopOpacity: 0.2645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8858,
    stopColor: "#00B5D7",
    stopOpacity: 0.1142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7149 14.9987) scale(8.47915 8.47891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5427 14.7021) scale(18.0354 18.0355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_578_447537",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9226 18.3412) scale(10.7036 10.7036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.28a3adb383d68f4dc252c6f2dac68e28.svg";
export { ForwardRef as ReactComponent };